import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MenuItem, MessageService } from 'primeng/api';
import { VendorTsService } from '../../../../service/vendor/vendor.ts.service';
import { AuthService } from '../../../../service/frappe/auth.service';
import { UserService } from '../../../../service/user-service';
import { NavigationExtras, Router } from '@angular/router';
import { AbstractControl } from '@angular/forms';
import { ShipmentASN } from '../../../../service/shipment-asn.service';
import { Subscription } from 'rxjs';
import { an } from '@fullcalendar/core/internal-common';
import { environment } from '../../../../../environments/environment';
import { IFSCResponse } from '../../../../models/ifsc-response';
interface SummaryData{
  key:string
  oldValue:string
  newValue:string
}
interface CityAndState {
  city: string;
  state: string;
  state_code: string;
  name: string;
}
interface PlantWithCode{
  plant__code:string
  name1:string
}
@Component({
  selector: 'app-change-detail',
  templateUrl: './change-detail.component.html',
  styleUrl: './change-detail.component.scss'
})
export class ChangeDetailComponent {

  @Output() userFoundChange = new EventEmitter<boolean>();
  private subscriptions: Subscription[] = [];
  contactForm!: FormGroup;
  rockmancontactForm!: FormGroup;
  savedContacts: any[] = [];
  msmeYearList: any[] = [];
  noContacts: boolean = false;
  noRockmanContacts: boolean = false;
  enableMSMEUploadButton: boolean = true;
  enableMSMEYearInvalidMessage: boolean = false;
  createSub$!: Subscription;
  ifscResponse: IFSCResponse[] = [];
  ifscDialog: boolean = false
  content = "Contact";
  detail1 = 'Contact saved or updated successfully';
  detail2 = 'Error saving or updating contact';
  detail3 = 'Invalid contact data. Cannot save or update';

  registrationForm!: FormGroup;
  items: MenuItem[] = [];
  FRAPPE_API_URL = environment.FRAPPE_API_URL;
  FRAPPE_API_URL_PROD = environment.FRAPPE_API_URL;
  displayDialog: boolean = false;
  missingFields: string[] = [];
  msmeCertificateFile: File | null = null;
  companyRegistrationFile: File | null = null;
  vendorImageFile: File | null = null;
  otherDocumentsFiles: File | null = null;
  uploadGstFile: File | null = null;
  uploadCIN: File | null = null;
  cancelledCheque: File | null = null;
  selfDeclarationByVendor: File | null = null;
  evaluationSheet: File | null = null;
  mcaDocument: File | null = null;
  panDocument: File | null = null;
  document1: File | null = null;
  document2: File | null = null;
  document3: File | null = null;
  document4: File | null = null;
  document5: File | null = null;
  document6: File | null = null;
  activeIndex: number = 0;
  loggedInUser: string = '';
  submitted = false;
  selectedValue: any;
  selectedValue1: any;
  checkbox1: boolean = false;
  checkbox2: boolean = false;
  checkbox3: boolean = false;
  checkbox4: boolean = false;
  evaluationSheetUrl!: string;
  document1Url!: string;
  document2Url!: string;
  document3Url!: string;
  document4Url!: string;
  document5Url!: string;
  document6Url!: string;
  msme_certificateUrl!: string
  company_registrationUrl!: string
  other_documentsUrl!: string
  upload_cinUrl!: string
  propertiery_imgUrl!: string
  mca_documentUrl!: string
  self_declaration_by_vendorUrl!: string
  pan_documentUrl!: string
  upload_gstUrl!: string
  cancelled_chequeUrl!: string
  plantList: any[] = [];
  formValues:any
  isDisablePan: boolean = true;
  isDisablePanDoc:boolean=true
  isNotEditable: boolean = true;
  isGSTYESEditable: boolean = true;
  isLoading: boolean = false;
  isIndustry: boolean = false;
  // countries: any[] | undefined
  selectedIFSC!: any;
  countries_code: any;
  selectedCountrieCode?: any;
  selectedOptionLabel: string = 'name';
  business_name:string=''
  currentYear: number = 0;
  financialPreviousYear: number = 0;
  financialOneYearBeforePreviousYear: number = 0;
  financialtwoYearsBeforePreviousYear: number = 0;
  summaryValue: SummaryData[] = [];
  emailErrors: { [key: number]: boolean } = {};
  telephoneErrors: { [key: number]: boolean } = {};
  mobileErrors: { [key: number]: boolean } = {};
  cityAndStateList: any[] = [];
  multipleBankDetailForm!: FormGroup;
  bankUploadedFiles: any[] = [];
  patchBankUploaded: any[] = [];
  deleted_multiple_bank_list: any[] = [];
  deleted_contact_list: any[] = [];
  deleted_contact_person_list: any[] = [];
  selectedBankIndex: number | null = null;
  isBankChange:boolean=false
  isGst:boolean=false
  ispan:boolean=false
  options = [
    { label: 'Individual', value: 'Individual' },
    { label: 'Partnership', value: 'Partnership' },
    { label: 'Corporation', value: 'Corporation' },
    {
      label: 'Limited Liability Co. (LLC)',
      value: 'Limited Liability Co. (LLC)',
    },
    { label: 'Limited', value: 'Limited' },
    { label: 'Govt.Org', value: 'Govt.Org' },
    { label: 'Private Limited', value: 'Private Limited' },
  ];
  MCA = [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' },
  ];
  VendorType = [
    { label: 'Goods', value: 'Goods' },
    { label: 'Service', value: 'Service' },
  ];
  SelectIndustryType = [
    { label: 'Micro Industry', value: '0001' },
    { label: 'Small Industry', value: '0002' },
    { label: 'Medium Industry', value: '0003' },
    { label: 'Large Industry', value: '0004' },
    { label: 'Other', value: '0005' },
  ];

  countries_List = [
    { label: 'Afghanistan', value: 'AF' },
    { label: 'Albania', value: 'AL' },
    { label: 'Algeria', value: 'DZ' },
    { label: 'Andorra', value: 'AD' },
    { label: 'Angola', value: 'AO' },
    { label: 'Antigua and Barbuda', value: 'AG' },
    { label: 'Argentina', value: 'AR' },
    { label: 'Armenia', value: 'AM' },
    { label: 'Australia', value: 'AU' },
    { label: 'Austria', value: 'AT' },
    { label: 'Azerbaijan', value: 'AZ' },
    { label: 'Bahamas', value: 'BS' },
    { label: 'Bahrain', value: 'BH' },
    { label: 'Bangladesh', value: 'BD' },
    { label: 'Barbados', value: 'BB' },
    { label: 'Belarus', value: 'BY' },
    { label: 'Belgium', value: 'BE' },
    { label: 'Belize', value: 'BZ' },
    { label: 'Benin', value: 'BJ' },
    { label: 'Bhutan', value: 'BT' },
    { label: 'Bolivia', value: 'BO' },
    { label: 'Bosnia and Herzegovina', value: 'BA' },
    { label: 'Botswana', value: 'BW' },
    { label: 'Brazil', value: 'BR' },
    { label: 'Brunei', value: 'BN' },
    { label: 'Bulgaria', value: 'BG' },
    { label: 'Burkina Faso', value: 'BF' },
    { label: 'Burundi', value: 'BI' },
    { label: 'Cabo Verde', value: 'CV' },
    { label: 'Cambodia', value: 'KH' },
    { label: 'Cameroon', value: 'CM' },
    { label: 'Canada', value: 'CA' },
    { label: 'Central African Republic', value: 'CF' },
    { label: 'Chad', value: 'TD' },
    { label: 'Chile', value: 'CL' },
    { label: 'China', value: 'CN' },
    { label: 'Colombia', value: 'CO' },
    { label: 'Comoros', value: 'KM' },
    { label: 'Congo, Democratic Republic of the', value: 'CD' },
    { label: 'Congo, Republic of the', value: 'CG' },
    { label: 'Costa Rica', value: 'CR' },
    { label: 'Croatia', value: 'HR' },
    { label: 'Cuba', value: 'CU' },
    { label: 'Cyprus', value: 'CY' },
    { label: 'Czech Republic', value: 'CZ' },
    { label: 'Denmark', value: 'DK' },
    { label: 'Djibouti', value: 'DJ' },
    { label: 'Dominica', value: 'DM' },
    { label: 'Dominican Republic', value: 'DO' },
    { label: 'Ecuador', value: 'EC' },
    { label: 'Egypt', value: 'EG' },
    { label: 'El Salvador', value: 'SV' },
    { label: 'Equatorial Guinea', value: 'GQ' },
    { label: 'Eritrea', value: 'ER' },
    { label: 'Estonia', value: 'EE' },
    { label: 'Eswatini', value: 'SZ' },
    { label: 'Ethiopia', value: 'ET' },
    { label: 'Fiji', value: 'FJ' },
    { label: 'Finland', value: 'FI' },
    { label: 'France', value: 'FR' },
    { label: 'Gabon', value: 'GA' },
    { label: 'Gambia', value: 'GM' },
    { label: 'Georgia', value: 'GE' },
    { label: 'Germany', value: 'DE' },
    { label: 'Ghana', value: 'GH' },
    { label: 'Greece', value: 'GR' },
    { label: 'Grenada', value: 'GD' },
    { label: 'Guatemala', value: 'GT' },
    { label: 'Guinea', value: 'GN' },
    { label: 'Guinea-Bissau', value: 'GW' },
    { label: 'Guyana', value: 'GY' },
    { label: 'Haiti', value: 'HT' },
    { label: 'Honduras', value: 'HN' },
    { label: 'Hungary', value: 'HU' },
    { label: 'Iceland', value: 'IS' },
    { label: 'India', value: 'IN' },
    { label: 'Indonesia', value: 'ID' },
    { label: 'Iran', value: 'IR' },
    { label: 'Iraq', value: 'IQ' },
    { label: 'Ireland', value: 'IE' },
    { label: 'Israel', value: 'IL' },
    { label: 'Italy', value: 'IT' },
    { label: 'Ivory Coast', value: 'CI' },
    { label: 'Jamaica', value: 'JM' },
    { label: 'Japan', value: 'JP' },
    { label: 'Jordan', value: 'JO' },
    { label: 'Kazakhstan', value: 'KZ' },
    { label: 'Kenya', value: 'KE' },
    { label: 'Kiribati', value: 'KI' },
    { label: 'Kuwait', value: 'KW' },
    { label: 'Kyrgyzstan', value: 'KG' },
    { label: 'Laos', value: 'LA' },
    { label: 'Latvia', value: 'LV' },
    { label: 'Lebanon', value: 'LB' },
    { label: 'Lesotho', value: 'LS' },
    { label: 'Liberia', value: 'LR' },
    { label: 'Libya', value: 'LY' },
    { label: 'Liechtenstein', value: 'LI' },
    { label: 'Lithuania', value: 'LT' },
    { label: 'Luxembourg', value: 'LU' },
    { label: 'Madagascar', value: 'MG' },
    { label: 'Malawi', value: 'MW' },
    { label: 'Malaysia', value: 'MY' },
    { label: 'Maldives', value: 'MV' },
    { label: 'Mali', value: 'ML' },
    { label: 'Malta', value: 'MT' },
    { label: 'Marshall Islands', value: 'MH' },
    { label: 'Mauritania', value: 'MR' },
    { label: 'Mauritius', value: 'MU' },
    { label: 'Mexico', value: 'MX' },
    { label: 'Micronesia', value: 'FM' },
    { label: 'Moldova', value: 'MD' },
    { label: 'Monaco', value: 'MC' },
    { label: 'Mongolia', value: 'MN' },
    { label: 'Montenegro', value: 'ME' },
    { label: 'Morocco', value: 'MA' },
    { label: 'Mozambique', value: 'MZ' },
    { label: 'Myanmar', value: 'MM' },
    { label: 'Namibia', value: 'NA' },
    { label: 'Nauru', value: 'NR' },
    { label: 'Nepal', value: 'NP' },
    { label: 'Netherlands', value: 'NL' },
    { label: 'New Zealand', value: 'NZ' },
    { label: 'Nicaragua', value: 'NI' },
    { label: 'Niger', value: 'NE' },
    { label: 'Nigeria', value: 'NG' },
    { label: 'North Korea', value: 'KP' },
    { label: 'North Macedonia', value: 'MK' },
    { label: 'Norway', value: 'NO' },
    { label: 'Oman', value: 'OM' },
    { label: 'Pakistan', value: 'PK' },
    { label: 'Palau', value: 'PW' },
    { label: 'Panama', value: 'PA' },
    { label: 'Papua New Guinea', value: 'PG' },
    { label: 'Paraguay', value: 'PY' },
    { label: 'Peru', value: 'PE' },
    { label: 'Philippines', value: 'PH' },
    { label: 'Poland', value: 'PL' },
    { label: 'Portugal', value: 'PT' },
    { label: 'Qatar', value: 'QA' },
    { label: 'Romania', value: 'RO' },
    { label: 'Romania', value: 'RO' },
    { label: 'Russia', value: 'RU' },
    { label: 'Rwanda', value: 'RW' },
    { label: 'Saint Kitts and Nevis', value: 'KN' },
    { label: 'Saint Lucia', value: 'LC' },
    { label: 'Saint Vincent and the Grenadines', value: 'VC' },
    { label: 'Samoa', value: 'WS' },
    { label: 'San Marino', value: 'SM' },
    { label: 'Sao Tome and Principe', value: 'ST' },
    { label: 'Saudi Arabia', value: 'SA' },
    { label: 'Senegal', value: 'SN' },
    { label: 'Serbia', value: 'RS' },
    { label: 'Seychelles', value: 'SC' },
    { label: 'Sierra Leone', value: 'SL' },
    { label: 'Singapore', value: 'SG' },
    { label: 'Slovakia', value: 'SK' },
    { label: 'Slovenia', value: 'SI' },
    { label: 'Solomon Islands', value: 'SB' },
    { label: 'Somalia', value: 'SO' },
    { label: 'South Africa', value: 'ZA' },
    { label: 'South Korea', value: 'KR' },
    { label: 'South Sudan', value: 'SS' },
    { label: 'Spain', value: 'ES' },
    { label: 'Sri Lanka', value: 'LK' },
    { label: 'Sudan', value: 'SD' },
    { label: 'Suriname', value: 'SR' },
    { label: 'Sweden', value: 'SE' },
    { label: 'Switzerland', value: 'CH' },
    { label: 'Syria', value: 'SY' },
    { label: 'Taiwan', value: 'TW' },
    { label: 'Tajikistan', value: 'TJ' },
    { label: 'Tanzania', value: 'TZ' },
    { label: 'Thailand', value: 'TH' },
    { label: 'Timor-Leste', value: 'TL' },
    { label: 'Togo', value: 'TG' },
    { label: 'Tonga', value: 'TO' },
    { label: 'Trinidad and Tobago', value: 'TT' },
    { label: 'Tunisia', value: 'TN' },
    { label: 'Turkey', value: 'TR' },
    { label: 'Turkmenistan', value: 'TM' },
    { label: 'Tuvalu', value: 'TV' },
    { label: 'Uganda', value: 'UG' },
    { label: 'Ukraine', value: 'UA' },
    { label: 'United Arab Emirates', value: 'AE' },
    { label: 'United Kingdom', value: 'GB' },
    { label: 'United States', value: 'US' },
    { label: 'Uruguay', value: 'UY' },
    { label: 'Uzbekistan', value: 'UZ' },
    { label: 'Vanuatu', value: 'VU' },
    { label: 'Vatican City', value: 'VA' },
    { label: 'Venezuela', value: 'VE' },
    { label: 'Vietnam', value: 'VN' },
    { label: 'Yemen', value: 'YE' },
    { label: 'Zambia', value: 'ZM' },
    { label: 'Zimbabwe', value: 'ZW' },
  ];

  GST_Registered = [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' },
  ];
  Company_Title = [
    { label: 'Company', value: 'Company' },
    { label: 'MR.', value: 'Mr.' },
    { label: 'Ms.', value: 'Ms.' },
    { label: 'Mr. & Mrs.', value: 'Mr. & Mrs.' },
  ];
  Rockman_contact_department = [
    { label: 'Managining Director', value: '0001' },
    { label: 'Purchaing', value: '0002' },
    { label: 'Sales', value: '0003' },
    { label: 'Organization', value: '0004' },
    { label: 'Adminstration', value: '0005' },
    { label: 'Production', value: '0006' },
    { label: 'Quality Assurance', value: '0007' },
    { label: 'Secretaries', value: '0008' },
    { label: 'Financial Department', value: '0009' },
    { label: 'Legal Department', value: '0010' },
  ];

  Rockman_contact_function = [
    { label: 'Executive Board', value: '01' },
    { label: 'Head of Purchaing', value: '02' },
    { label: 'Head of Sales', value: '03' },
    { label: 'Head of Personnel', value: '04' },
    { label: 'Janitor', value: '05' },
    { label: 'Head of the Canteen', value: '06' },
    { label: 'Personal Assistant', value: '07' },
    { label: 'Edp Manager', value: '08' },
    { label: 'Fin.Accountg Manager', value: '09' },
    { label: 'Marketing Manager', value: '10' },
  ];

  countries = [
    { label: 'Afghanistan (+93)', value: '+93' },
    { label: 'Australia (+61)', value: '+61' },
    { label: 'China (+86)', value: '+86' },
    { label: 'Egypt (+20)', value: '+20' },
    { label: 'France (+33)', value: '+33' },
    { label: 'Germany (+49)', value: '+49' },
    { label: 'India (+91)', value: '+91' },
    { label: 'Japan (+81)', value: '+81' },
    { label: 'Spain (+34)', value: '+34' },
    { label: 'United Kingdom (+44)', value: '+44' },
    { label: 'United States (+1)', value: '+1' },
  ];
  state = [
    { label: 'Andaman and Nico.In.', value: '26' },
    { label: 'Andra Pradesh', value: '01' },
    { label: 'Arunachal Pradesh', value: '02' },
    { label: 'Assam', value: '03' },
    { label: 'Bihar', value: '04' },
    { label: 'Chandigarh', value: '27' },
    { label: 'Chhaattisgarh', value: '33' },
    { label: 'Dadra und Nagar Hav.', value: '28' },
    { label: 'Daman und Diu', value: '29' },
    { label: 'Delhi', value: '30' },
    { label: 'Exports', value: '96' },
    { label: 'Goa', value: '05' },
    { label: 'Gujarat', value: '06' },
    { label: 'Haryana', value: '07' },
    { label: 'Himachal Pradesh', value: '08' },
    { label: 'Jammu and Kashmir', value: '09' },
    { label: 'Jharkhand', value: '34' },
    { label: 'Karnataka', value: '10' },
    { label: 'Kerala', value: '11' },
    { label: 'Lakshadweep', value: '31' },
    { label: 'Madhya Pradesh', value: '12' },
    { label: 'Maharashtra', value: '13' },
    { label: 'Manipur', value: '14' },
    { label: 'Megalaya', value: '15' },
    { label: 'Mizoram', value: '16' },
    { label: 'Nagaland', value: '17' },
    { label: 'Orissa', value: '18' },
    { label: 'Other - Exports', value: '00' },
    { label: 'Pondicherry', value: '32' },
    { label: 'Punjab', value: '19' },
    { label: 'Rajasthan', value: '20' },
    { label: 'Sikkim', value: '21' },
    { label: 'Tamil Nadu', value: '22' },
    { label: 'Telangana', value: '36' },
    { label: 'Tripura', value: '23' },
    { label: 'Uttar Pradesh', value: '24' },
    { label: 'Uttarakhand', value: '35' },
    { label: 'West Bengal', value: '25' },
  ];

  options1 = [
    { label: 'Billing', value: 'Billing' },
    { label: 'Shipping', value: 'Shipping' },
    { label: 'Office', value: 'Office' },
    { label: 'Personal', value: 'Personal' },
    { label: 'Plant', value: 'Plant' },
    { label: 'Postal', value: 'Postal' },
    { label: 'Shop', value: 'Shop' },
    { label: 'Subsidiary', value: 'Subsidiary' },
    { label: 'Warehouse', value: 'Warehouse' },
    { label: 'Current', value: 'Current' },
    { label: 'Permanent', value: 'Permanent' },
    { label: 'Other', value: 'Other' },
  ];

  bankPlantNameAndCode = [
    { label: 'ROCKMAN HARIDWAR(RILH)', value: 'RILH' },
    { label: 'ROCKMAN LUDHIANA(RILL)', value: 'RILL' },
    { label: 'ROCKMAN MANGLI(RILM)', value: 'RILM' },
    { label: 'ROCKMAN BAWAL(RILB)', value: 'RILB' },
    { label: 'ROCKMAN VADODARA(RILV)', value: 'RILV' },
    { label: 'ROCKMAN TIRUPATI(RILT)', value: 'RILT' },
    { label: 'ROCKMAN CHENNAI(RILC)', value: 'RILC' },
    { label: 'ROCKMAN CHENNAI 2(RIC2)', value: 'RIC2' },
    { label: 'ROCKMAN CORPORTAE(RILG)', value: 'RILG' },
  ]

  fieldLabels: { [key: string]: string } = {
    "new_vm_contact_detail":"CONTACT DETAILS",
    "new_rockman_contact_detail":"CONTACT PERSON",
    'business_name': 'Information (Business Name)',
    'mca_number': 'Information (MCA Number)',
    'mca_document': 'Information (MCA FILE)',
    'plant': 'Information (Plant)',
    'note': 'please accept agreement by clicking checkbox',
    'pan_no': 'Legal Details (PAN No)',
    'msme_no': 'Legal Details (MSME Number)',
    'msme_certificate': 'Legal Details (Msme Certificate Fileupload)',
    'company_registration': 'Legal Details (Company Registration Fileupload)',
    'other_documents': 'Legal Details (Other Documents Fileupload)',
    'cin_no': 'Legal Details (CIN No)',
    'upload_cin': 'Legal Details (Upload CIN)',
    'short_name': 'Information (Short Name)',
    'vendor_classification': 'Vendor Classification (VENDOR CLASSIFICATION)',
    'primary_address.address_title': 'Primary Address (Address Title)',
    'primary_address.city': 'Primary Address (City)',
    'primary_address.state': 'Primary Address (State/Province)',
    'primary_address.postal_code': 'Primary Address (Postal Code)',
    'primary_address.email_address': 'Primary Address (Email Address)',
    'primary_address.address_line_1': 'Primary Address (Address Line 1)',
    'primary_address.address_line_2': 'Primary Address (District)',
    'primary_address.address_type': 'Primary Address (Address Type)',
    'primary_address.contact_person.name1': 'Contact Details (Name)',
    'primary_address.contact_person.mobile_no': 'Contact Details (Mobile No)',
    'primary_address.contact_person.e_mail_id': 'Contact Details (Email ID)',
    'primary_address.contact_person.website_url': 'Contact Details (Website/ URL)',
    // 'primary_address.bank_detail.account_holder__registered_name': 'Bank Details (Account Holder Name)',
    // 'primary_address.bank_detail.account_no': 'Bank Details (Account No)',
    // 'primary_address.bank_detail.ifsc_code': 'Bank Details (IFSC Code)',
    // 'primary_address.bank_detail.bank_name': 'Bank Details (Bank Name)',
    // 'primary_address.bank_detail.bank_address': 'Bank Details (Bank Address)',
    // 'primary_address.bank_detail.cancelled_cheque': 'Bank Details (Bank Document)',
    'primary_address.tax_details.gstn': 'Tax Details (GSTN)',
    'primary_address.tax_details.upload_gst': 'Tax Details (Upload GST)',
    'self_declaration_by_vendor': 'Legal Details(Self Declaration By Vendor)',
    'evaluation_sheet': 'Documents as required in Evaluation Sheet( Evaluation Sheet)',
    'document_1': 'Documents as required in Evaluation Sheet(Company Profile)',
    'document_2': 'Documents as required in Evaluation Sheet(Balance Sheet)',
    'document_1_name': 'Company Profile Name required',
    'document_2_name': 'Balance Sheet Name required',
    // "primary_address.bank_detail.bank_region": 'Bank Details (Bank Region)',
    // "primary_address.bank_detail.bank_city": 'Bank Details (Bank City)',
    "select_industry_type": "select industry type",
    "gst_registered": "select gst registered (Yes/No)",
    "pan_document": "Please Upload Pan Document",
    // "primary_address.bank_detail.branch_name": "Bank Details(Branch Name)",
    // "bank_city": "Bank Details(Bank City)",
    // "bank_region": "Bank Details(Bank Region)",

    "rockmancontacts[0].first_name": "Contact person 1 (First Name)",
    "rockmancontacts[0].last_name": "Contact person 1 (Last Name)",
    "rockmancontacts[0].rockman_contact_department": "Contact person 1 (Contact Departmant)",
    "rockmancontacts[0].rockman_contact_function": "Contact person 1 (Function)",
    // "contacts[0].vm_name": "Contact Details (Name)",
    // "contacts[0].telephone": "Contact Details 1 (Telephone)",
    "contacts[0].email_id": "Contact Details 1 (Email)",
    "contacts[0].mobile_phone": "Contact Details 1 (Mobile Phone)",
  };

  constructor(
    private fb: FormBuilder,
    public messageService: MessageService,
    private vendorService: VendorTsService,
    public authService: AuthService,
    public userService: UserService,
    private router: Router,
    private shipment_asn: ShipmentASN
  ) { }

  ngOnInit() {
    this.contactForm = this.fb.group({
      contacts: this.fb.array([]),
    });
    this.multipleBankDetailForm = this.fb.group({
      multipleBank: this.fb.array([]),
    });

    this.rockmancontactForm = this.fb.group({
      rockmancontacts: this.fb.array([]),
    });
    this.addRockmanContact();

    this.registrationForm = this.fb.group(
      {
        new_vm_contact_detail: this.fb.control('',[Validators.required]),
        new_rockman_contact_detail: this.fb.control('',[Validators.required]),
        vendor_code: [''],
        plant: ['',Validators.required],
        note: ['',],
        company_title: [''],
        ministry_of_corporate_affairsmca: [''],
        mca_number: [''],
        select_industry_type: ['', Validators.required],
        gst_registered: ['', Validators.required],
        vendor_type: [''],
        business_name: ['', Validators.required],
        vendor_classification: ['',Validators.required],
        short_name: ['', Validators.required],
        status: [''],
        propertiery_img: [''],
        previous_year: [''],
        one_year_before_previous_year: [''],
        two_years_before_previous_year: [''],
        financial_previous_year: [''],
        financial_one_year_before_previous_year: [''],
        financial_two_years_before_previous_year: [''],
        legal_name: [''],
        pan_no: ['', [Validators.required, this.panValidator]],
        cin_no: ['', [Validators.required]],
        tin_no: [''],
        din_no: [''],
        msme_no: [''],
        aadhar_no: ['', [Validators.pattern(/^\d{12}$/)]],
        msme_certificate: [''],
        company_registration: ['',],
        other_documents: [''],
        upload_cin: ['',],
        self_declaration_by_vendor: ['',],
        mca_document: [''],
        pan_document: ['',],
        evaluation_sheet: ['',],
        document_1: ['',],
        document_2: ['',],
        document_3: ['',],
        document_4: ['',],
        document_5: ['',],
        document_6: ['',],
        document_1_name: [''],
        document_2_name: [''],
        document_3_name: [''],
        document_4_name: [''],
        document_5_name: [''],
        document_6_name: [''],
        get_user: [''],
        msme_expiry_year: [''],
        highlights_detail: [''],
        primary_address: this.fb.group({
          address_title: ['', Validators.required],
          address_line_1: ['', Validators.required],
          address_line_2: ['', Validators.required],
          city: ['',Validators.required],
          country: ['', Validators.required],
          state: ['',Validators.required],
          state1: [''],
          postal_code: ['', [Validators.required, Validators.pattern('^[0-9]{1,6}$')]],
          email_address: ['', [Validators.email]],
          phone_no: [''],
          fax: [''],
          address_summary: [''],
          address_type: [''],
          preferred_billing_address: [''],
          preferred_shipping_address: [''],
          disabled: [''],
          is_primary: [''],
          contact_person: this.fb.group({
            name1: [''],
            phone_no: [''],
            mobile_no: [''],
            e_mail_id: [''],
            website_url: [''],
            alternate_email_id: [''],
          }),
          // bank_detail: this.fb.group({
          //   account_holder__registered_name: ['', Validators.required],
          //   account_no: ['', [Validators.required, this.noSpecialCharactersValidator]],
          //   bank_name: ['', Validators.required],
          //   bank_address: ['', Validators.required],
          //   ifsc_code: ['', [Validators.required]],
          //   cancelled_cheque: [''],
          //   branch_name: ['', Validators.required],
          //   bank_city: ['', Validators.required],
          //   bank_region: ['', Validators.required],
          // }),
          multiple_bank_detail: this.fb.control('',[Validators.required]),
          tax_details: this.fb.group({
            gstn: [''],
            vat_registration_number: [''],
            service_tax_registration_number: [''],
            upload_gst: [''],
          }),
        }),
      },
      { validator: this.emailMatchValidator }
    );
    this.CityAndState();


    // Subscribe to changes in gst_registered dropdown to dynamically update validators

    // this.registrationForm.get('primary_address.tax_details.gst_registered')?.valueChanges.subscribe((value:any) => {
    //   this.updateGstnValidators(value);
    // });
    // this.registrationForm.get('gst_registered')?.valueChanges.subscribe(() => {
    //   this.setGSTNValidation();
    // });

    this.items = [
      {
        label: 'General Information',
        command: (event: any) => {
          this.activeIndex = 0;
          this.messageService.add({
            severity: 'info',
            summary: 'First Step',
            detail: 'General Information',
          });
        },
      },
      {
        label: 'Registration Details',
        command: (event: any) => {
          this.activeIndex = 1;
          this.messageService.add({
            severity: 'info',
            summary: 'Second Step',
            detail: 'Registration Details',
          });
        },
      },
    ];
    this.getLoggedInUser();

    this.generateYearList();
    // this.CityAndState()

    this.currentYear = new Date().getFullYear();
    this.financialPreviousYear = this.currentYear - 1;
    this.financialOneYearBeforePreviousYear = this.currentYear - 2;
    this.financialtwoYearsBeforePreviousYear = this.currentYear - 3;
  }
  CityAndState(){
    this.vendorService.getCityAndState().then((res)=>{
      this.cityAndStateList = res.message
      this.getPlantList();
    }).catch((error)=>{
      console.log(error)
    })
  }

  generateYearList(): void {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 10;
    const endYear = currentYear + 10;

    for (let year = startYear; year <= endYear; year++) {
      // this.msmeYearList.push(year);
      this.msmeYearList.push({ name: `Year ${year}`, year: year });
    }
  }

  onMsmeExpiryYearChange(event: any) {
    const currentYear = new Date().getFullYear();
    if (event >= currentYear) {
      this.enableMSMEUploadButton = false
    } else {
      this.enableMSMEUploadButton = true
    }
    if (event < currentYear) {
      this.enableMSMEYearInvalidMessage = true
    } else {
      this.enableMSMEYearInvalidMessage = false
    }
  }

  getPlantLabel(plant: string): any {
    if (this.plantList) {
      const plantName = this.plantList.find((p) => p.plant__code === plant)
      return plantName.plant__code
    }
  }
  getCity(city: string): any {
    const city1= this.cityAndStateList.find((p) => p.city && p.city.toUpperCase() === city.toUpperCase())
    if (city1) {
      return city1
    }else{
      return city
    }
  }

  updateGstnValidators(value: string): void {
    const gstnControl = this.registrationForm.get('primary_address.tax_details.gstn');
    if (value === 'Yes') {
      gstnControl?.setValidators([Validators.required, this.gstnValidator]);
      this.isGSTYESEditable=true
      this.isDisablePan = true
      this.ispan = true
      // pan_no?.disable();
    } else {
      this.ispan = false
      gstnControl?.clearValidators();
      // pan_no?.enable();
      this.isGSTYESEditable=false
      this.isDisablePan = false
      // this.registrationForm.get('pan_no')?.setValue('');
      this.isDisablePanDoc=false
    }
    gstnControl?.updateValueAndValidity(); // Update validity immediately
  }

  onGstnBlur(gstn: any) {
    const gstnValue = (gstn.target as HTMLInputElement).value;
    const upload_gst = this.registrationForm.get('primary_address.tax_details.upload_gst');
    const pan_document = this.registrationForm.get('pan_document');
    if (gstn) {
      this.registrationForm.patchValue({
        upload_gst: '',
      });
      this.uploadGstFile = null;
      this.upload_gstUrl=''
      upload_gst?.setValidators(Validators.required);
      this.registrationForm.patchValue({
        pan_document: '',
      });
      this.panDocument = null;
      this.pan_documentUrl=''
      pan_document?.setValidators(Validators.required);
    }
    const panNo = gstnValue.substring(2, 12);
    if (panNo) {
      this.isDisablePanDoc=true
      this.registrationForm.get('pan_no')?.setValue(panNo)
    }
    upload_gst?.updateValueAndValidity(); // Update validity immediately
    pan_document?.updateValueAndValidity(); // Update validity immediately
  }
  fetchVendorDetails(): void {

    this.vendorService.getVendorForChangeDetail().then((vendorDetails: any) => {
      this.business_name=vendorDetails.message?.business_name
      if (vendorDetails.message?.address_details?.country === 'IN') {
        this.onStateChange('IN')
        // this.getStateLabel(vendorDetails.message?.address_details?.state, vendorDetails.message?.address_details?.country)
      }

      if(vendorDetails.message?.select_industry_type) {
        this.SelectIndustryType1(vendorDetails.message?.select_industry_type)
      }

     this.formValues = {
        vendor_code: vendorDetails.message?.vendor_code || '',
        new_rockman_contact_detail:'',
        new_vm_contact_detail:'',
        // plant: vendorDetails.message?.plant || '',
        plant: vendorDetails.message?.plant ? this.getPlantLabel(vendorDetails.message?.plant): '',
        note: vendorDetails.note || '',
        company_title: vendorDetails.message?.company_title || '',
        ministry_of_corporate_affairsmca: vendorDetails.message?.ministry_of_corporate_affairsmca || '',
        mca_number: vendorDetails.message?.mca_number || '',
        select_industry_type: vendorDetails.message?.select_industry_type || '',
        gst_registered: vendorDetails.message?.gst_registered || '',
        vendor_type: vendorDetails.message?.vendor_type || '',
        business_name: vendorDetails.message?.business_name || '',
        vendor_classification: vendorDetails.message?.vendor_classification || '',
        short_name: vendorDetails.message?.short_name || '',
        // status: vendorDetails.message?.status || 'PENDING_REVIEW',
        previous_year: vendorDetails.message?.previous_year || '',
        one_year_before_previous_year: vendorDetails.message?.one_year_before_previous_year || '',
        two_years_before_previous_year: vendorDetails.message?.two_years_before_previous_year || '',
        financial_previous_year: vendorDetails.message?.financial_previous_year || '',
        financial_one_year_before_previous_year: vendorDetails.message?.financial_one_year_before_previous_year || '',
        financial_two_years_before_previous_year: vendorDetails.message?.financial_two_years_before_previous_year || '',
        legal_name: vendorDetails.message?.legal_name || '',
        pan_no: this.isPanNo(vendorDetails.message?.pan_no || ''),
        cin_no: vendorDetails.message?.cin_no || '',
        tin_no: vendorDetails.message?.tin_no || '',
        din_no: vendorDetails.message?.din_no || '',
        msme_no: vendorDetails.message?.msme_no || '',
        msme_expiry_year: vendorDetails.message?.msme_expiry_year ?  this.getExpiryYear(vendorDetails.message?.msme_expiry_year) : '',
        aadhar_no: vendorDetails.message?.aadhar_no || '',
        msme_certificate: vendorDetails.message?.msme_certificate || '',
        mca_document: vendorDetails.message?.mca_document || '',
        company_registration: vendorDetails.message?.company_registration || '',
        other_documents: vendorDetails.message?.other_documents || '',
        pan_document: vendorDetails.message?.pan_document || '',
        propertiery_img: vendorDetails.message?.propertiery_img || '',
        upload_cin: vendorDetails.message?.upload_cin || '',
        self_declaration_by_vendor: vendorDetails.message?.self_declaration_by_vendor || '',
        evaluation_sheet: vendorDetails.message?.evaluation_sheet || '',
        document_1: vendorDetails.message?.document_1 || '',
        document_2: vendorDetails.message?.document_2 || '',
        document_3: vendorDetails.message?.document_3 || '',
        document_4: vendorDetails.message?.document_4 || '',
        document_5: vendorDetails.message?.document_5 || '',
        document_6: vendorDetails.message?.document_6 || '',
        document_1_name: vendorDetails.message?.document_1_name || '',
        document_2_name: vendorDetails.message?.document_2_name || '',
        document_3_name: vendorDetails.message?.document_3_name || '',
        document_4_name: vendorDetails.message?.document_4_name || '',
        document_5_name: vendorDetails.message?.document_5_name || '',
        document_6_name: vendorDetails.message?.document_6_name || '',
        get_user: vendorDetails.message?.get_user || '',
        primary_address: {
          address_title: vendorDetails.message?.address_details?.address_title || '',
          address_line_1: vendorDetails.message?.address_details?.address_line_1 || '',
          address_line_2: vendorDetails.message?.address_details?.address_line_2 || '',
          city: this.getCity(vendorDetails.message?.address_details?.city) || '',
          country: vendorDetails.message?.address_details?.country || '',
          state: this.getStateLabel(vendorDetails.message?.address_details?.state, vendorDetails.message?.address_details?.country) || '',
          postal_code: vendorDetails.message?.address_details?.postal_code || '',
          email_address: vendorDetails.message?.address_details?.email_address || '',
          phone_no: vendorDetails.message?.address_details?.phone_no || '',
          fax: vendorDetails.message?.address_details?.fax || '',
          address_summary: vendorDetails.message?.address_details?.address_summary || '',
          address_type: vendorDetails.message?.address_details?.address_type || '',
          preferred_billing_address: vendorDetails.message?.address_details?.preferred_billing_address || '',
          preferred_shipping_address: vendorDetails.message?.address_details?.preferred_shipping_address || '',
          disabled: vendorDetails.message?.address_details?.disabled || '',
          is_primary: vendorDetails.message?.address_details?.is_primary || '',
          contact_person: {
            name1: vendorDetails.message?.address_details?.contact_person?.name1 || '',
            phone_no: vendorDetails.message?.address_details?.contact_person?.phone_no || '',
            mobile_no: vendorDetails.message?.address_details?.contact_person?.mobile_no || '',
            e_mail_id: vendorDetails.message?.address_details?.contact_person?.e_mail_id || '',
            website_url: vendorDetails.message?.address_details?.contact_person?.website_url || '',
            alternate_email_id: vendorDetails.message?.address_details?.contact_person?.alternate_email_id || ''
          },
          multiple_bank_detail:'',
          // bank_detail: {
          //   account_holder__registered_name: vendorDetails.message?.address_details?.bank_detail?.account_holder__registered_name || '',
          //   account_no: vendorDetails.message?.address_details?.bank_detail?.account_no || '',
          //   bank_name: vendorDetails.message?.address_details?.bank_detail?.bank_name || '',
          //   bank_address: vendorDetails.message?.address_details?.bank_detail?.bank_address || '',
          //   ifsc_code: vendorDetails.message?.address_details?.bank_detail?.ifsc_code || '',
          //   cancelled_cheque: vendorDetails.message?.address_details?.bank_detail?.cancelled_cheque || '',
          //   branch_name: vendorDetails.message?.address_details?.bank_detail?.branch_name || '',
          //   bank_city: vendorDetails.message?.address_details?.bank_detail?.bank_city || '',
          //   bank_region: vendorDetails.message?.address_details?.bank_detail?.bank_region || ''
          // },
          tax_details: {
            gstn: this.isGstNo(vendorDetails.message?.address_details?.tax_details?.gstn || '',vendorDetails.message?.gst_registered || ''),
            vat_registration_number: vendorDetails.message?.address_details?.tax_details?.vat_registration_number || '',
            service_tax_registration_number: vendorDetails.message?.address_details?.tax_details?.service_tax_registration_number || '',
            upload_gst: vendorDetails.message?.address_details?.tax_details?.upload_gst || ''
          }
        }
      };

      this.registrationForm.patchValue(this.formValues);
      // if (this.formValues.gst_registered) {
      //   this.updateGstnValidators(this.formValues.gst_registered)
      // }

      // const contactsFormArray = this.rockmancontactForm.get('rockmancontacts') as FormArray;
      // console.log("contact form", contactsFormArray)
      // if (vendorDetails.message?.contacts) {
      //   vendorDetails.message.contacts.forEach((contact: any, index: number) => {
      //     contactsFormArray.at(index).patchValue({
      //       first_name: contact.first_name || '',
      //       last_name: contact.last_name || '',
      //       rockman_contact_department: contact.rockman_contact_department || '',
      //       rockman_contact_function: contact.rockman_contact_function || ''
      //     });
      //   });
      // }
      // const rockmanContactsFormArray = this.contactForm.get('contacts') as FormArray;
      // console.log("rockman contact", rockmanContactsFormArray);

      // if (vendorDetails.message?.vm_contacts) {
      //   vendorDetails.message.vm_contacts.forEach((vmContact: any) => {
      //     rockmanContactsFormArray.push(this.fb.group({
      //       vm_name: vmContact.vm_name || '',
      //       telephone: vmContact.telephone || '',
      //       mobile_phone: vmContact.mobile_phone || '',
      //       email_id: vmContact.email_id || ''
      //     }));
      //   });
      // }
      const contactsFormArray = this.rockmancontactForm.get('rockmancontacts') as FormArray;

      contactsFormArray.clear();

      const existingContacts = new Set<string>();

      if (vendorDetails.message?.contacts && vendorDetails.message.contacts.some((contact: any) =>
  contact.first_name || contact.last_name || contact.rockman_contact_department || contact.rockman_contact_function)) {
        vendorDetails.message.contacts.forEach((contact: any) => {
          const firstName = contact.first_name || '';
          const lastName = contact.last_name || '';
          const department = contact.rockman_contact_department || '';
          const functionValue = contact.rockman_contact_function || '';
          const uniqueKey = `${firstName}-${lastName}-${department}-${functionValue}`;

          if ((firstName || lastName || department || functionValue) && (!existingContacts.has(uniqueKey))) {
            if (existingContacts.size > 0){
              contactsFormArray.push(this.fb.group({
                first_name: [firstName],
                last_name: [lastName],
                rockman_contact_department: [department],
                rockman_contact_function: [functionValue],
                is_delete_person: ['']
              }));
          }else{
            contactsFormArray.push(this.fb.group({
              first_name: [firstName, Validators.required],
              last_name: [lastName, Validators.required],
              rockman_contact_department: [department, Validators.required],
              rockman_contact_function: [functionValue, Validators.required],
              is_delete_person: ['']
            }));
          }
            existingContacts.add(uniqueKey);
          }
        });
      } else {

        if (existingContacts.size > 0){
          contactsFormArray.push(this.fb.group({
            first_name: [''],
            last_name: [''],
            rockman_contact_department: [''],
            rockman_contact_function: [''],
            is_delete_person: ['']
          }));
        }else{
          contactsFormArray.push(this.fb.group({
            first_name: ['', Validators.required],
            last_name: ['', Validators.required],
            rockman_contact_department: ['', Validators.required],
            rockman_contact_function: ['', Validators.required],
            is_delete_person: ['']
          }));
        }
      }


      const rockmanContactsFormArray = this.contactForm.get('contacts') as FormArray;

      rockmanContactsFormArray.clear();
      const existingVMContacts = new Set<string>();
      if (vendorDetails.message?.vm_contacts && vendorDetails.message.vm_contacts.some((vm_contacts: any) =>
      vm_contacts.vm_name || vm_contacts.telephone || vm_contacts.mobile_phone || vm_contacts.email_id)){
        vendorDetails.message.vm_contacts.forEach((vmContact: any) => {
          const vmName = vmContact.vm_name || '';
          const telephone = vmContact.telephone || '';
          const mobilePhone = vmContact.mobile_phone || '';
          const emailId = vmContact.email_id || '';
          const uniqueKey = `${vmName}-${telephone}-${mobilePhone}-${emailId}`;

          if ((vmName || telephone || mobilePhone || emailId ) && (!existingVMContacts.has(uniqueKey))) {
            if (existingVMContacts.size > 0){
              rockmanContactsFormArray.push(this.fb.group({
                vm_name: [vmName],
                telephone: [telephone],
                mobile_phone: [mobilePhone],
                email_id: [emailId],
                is_delete_contact: ['']
              }));
            }else{
              rockmanContactsFormArray.push(this.fb.group({
                vm_name: [vmName],
                telephone: [telephone],
                mobile_phone: [mobilePhone,Validators.required],
                email_id: [emailId,Validators.required],
                is_delete_contact: ['']
              }));
            }
            existingVMContacts.add(uniqueKey);
          }
        });
      } else {

        if (existingVMContacts.size > 0){
          rockmanContactsFormArray.push(this.fb.group({
            vm_name: [''],
            telephone: [''],
            mobile_phone: [''],
            email_id: [''],
            is_delete_contact: ['']
          }));
        }else{
          rockmanContactsFormArray.push(this.fb.group({
            vm_name: [''],
            telephone: [''],
            mobile_phone: ['',Validators.required],
            email_id: ['',Validators.required],
            is_delete_contact: ['']
          }));
        }
      }


      const banksFormArray = this.multipleBankDetailForm.get('multipleBank') as FormArray;

      banksFormArray.clear();
      this.patchBankUploaded = []

      const existingbanks = new Set<string>();

      if (vendorDetails.message?.address_details.multiple_bank_detail && vendorDetails.message.address_details.multiple_bank_detail.length > 0) {
        vendorDetails.message.address_details.multiple_bank_detail.forEach((bank: any) => {
          const account_holder__registered_name = bank.account_holder__registered_name || '';
          const account_no = bank.account_no || '';
          const ifsc_code = bank.ifsc_code || '';
          const bank_name = bank.bank_name || '';
          const plant_code = bank.plant_code || '';
          const bank_address = bank.bank_address || '';
          const branch_name = bank.branch_name || '';
          const bank_city = bank.bank_city || '';
          const bank_region = bank.bank_region || '';
          const cancelled_cheque = bank.cancelled_cheque || '';
          const uniqueKey = `${account_holder__registered_name}-${account_no}-${ifsc_code}`;

          if ((account_holder__registered_name || plant_code || account_no || ifsc_code || bank_name ||bank_address ||branch_name || bank_city||bank_region || cancelled_cheque) && (!existingbanks.has(uniqueKey))) {
            banksFormArray.push(this.fb.group({
              account_holder__registered_name: [account_holder__registered_name, Validators.required],
              account_no: [account_no, [Validators.required, this.noSpecialCharactersValidator]],
              bank_name: [bank_name, Validators.required],
              plant_code: [plant_code, Validators.required],
              // bank_address: [bank_address, Validators.required],
              ifsc_code: [ifsc_code, [Validators.required]],
              cancelled_cheque: [cancelled_cheque],
              branch_name: [branch_name, Validators.required],
              is_delete_bank: [''],
              // bank_city: [bank_city, Validators.required], // Add bank_city here
              // bank_region: [bank_region, Validators.required], // Add bank_region here
            }));
            existingbanks.add(uniqueKey);
          }
          this.patchBankUploaded = vendorDetails.message?.address_details.multiple_bank_detail.map((bank: any) => ({
            account_holder__registered_name: bank.account_holder__registered_name || '',
            account_no: bank.account_no || '',
            ifsc_code: bank.ifsc_code || '',
            bank_name: bank.bank_name || '',
            plant_code: bank.plant_code || '',
            // bank_address: bank.bank_address || '',
            branch_name: bank.branch_name || '',
            // bank_city: bank.bank_city || '',
            // bank_region: bank.bank_region || '',
            cancelled_cheque: bank.cancelled_cheque || ''
          }));

        });
      } else {
        banksFormArray.push(this.fb.group({
          account_holder__registered_name: ['', Validators.required],
          account_no: ['', [Validators.required, this.noSpecialCharactersValidator]],
          bank_name: ['', Validators.required],
          plant_code: ['', Validators.required],
          // bank_address: ['', Validators.required],
          ifsc_code: ['', [Validators.required]],
          cancelled_cheque: [''],
          branch_name: ['', Validators.required],
          is_delete_bank: [''],
          // bank_city: ['', Validators.required], // Add bank_city here
          // bank_region: ['', Validators.required], // Add bank_region here
        }));
      }

      this.formValues.new_rockman_contact_detail=contactsFormArray.value
      this.formValues.new_vm_contact_detail=rockmanContactsFormArray.value
      this.formValues.primary_address.multiple_bank_detail=banksFormArray.value

      this.evaluationSheetUrl = vendorDetails.message?.evaluation_sheet || '';
      this.document1Url = vendorDetails.message?.document_1 || '';
      this.document2Url = vendorDetails.message?.document_2 || '';
      this.document3Url = vendorDetails.message?.document_3 || '';
      this.document4Url = vendorDetails.message?.document_4 || '';
      this.document5Url = vendorDetails.message?.document_5 || '';
      this.document6Url = vendorDetails.message?.document_6 || '';
      this.msme_certificateUrl = vendorDetails.message?.msme_certificate || '';
      this.company_registrationUrl = vendorDetails.message?.company_registration || '';
      this.other_documentsUrl = vendorDetails.message?.other_documents || '';
      this.upload_cinUrl = vendorDetails.message?.upload_cin || '';
      this.propertiery_imgUrl = vendorDetails.message?.propertiery_img || '';
      this.mca_documentUrl = vendorDetails.message?.mca_document || '';
      this.self_declaration_by_vendorUrl = vendorDetails.message?.self_declaration_by_vendor || '';
      this.pan_documentUrl = vendorDetails.message?.pan_document || '';
      this.upload_gstUrl = vendorDetails.message?.address_details?.tax_details?.upload_gst || '';
      // this.cancelled_chequeUrl = vendorDetails.message?.address_details?.bank_detail?.cancelled_cheque || '';
    }).catch(error => {
      console.error('Error fetching vendor details:', error);
    });
  }
  isGstNo(gst: string, gst_registered: string): string {
    const gstnControl = this.registrationForm.get('primary_address.tax_details.gstn');
    const gstnRegisteredControl = this.registrationForm.get('gst_registered');

    if (gst_registered === "Yes" && gst && gst.trim() !== "") {
      this.isGst=true
      // gstnControl?.disable();
      // gstnRegisteredControl?.disable();
      gstnControl?.clearValidators();
      gstnRegisteredControl?.clearValidators();
    } else {
      this.isGst=false
      // gstnControl?.enable();
      // gstnRegisteredControl?.enable();
      gstnControl?.setValidators([Validators.required, this.gstnValidator]);
      gstnRegisteredControl?.setValidators([Validators.required]);
    }
    gstnControl?.updateValueAndValidity();
    gstnRegisteredControl?.updateValueAndValidity();
    return gst;
  }

  isPanNo(pan:string): string{
    const pan_no = this.registrationForm.get('pan_no');
    if(pan.trim() !== ""){
      // pan_no?.disable();
      this.ispan=true
      pan_no?.clearValidators();
    }else{
      this.ispan=false
      pan_no?.setValidators([Validators.required,this.panValidator]);
      // pan_no?.enable();
    }
    pan_no?.updateValueAndValidity();
    return pan;
  }

  // getStateLabel(value: string, country: any,city:string): any {
  //   // const stateObj = this.cityAndStateList.find(s => s.state_code === value && s.city === city);
  //   if (country === 'IN' && city && value) {
  //     // Convert city to uppercase for case-insensitive comparison, only if it's a valid string
  //     const cityUpper = city ? city.toUpperCase() : ''; // Handle null/undefined city gracefully

  //     // Build the lookup map with uppercase city comparison, checking if item.city exists
  //     const lookupMap = this.cityAndStateList.reduce((map, item) => {
  //       if (item.city) { // Ensure item.city is not null or undefined
  //         const key = `${item.state_code}_${item.city.toUpperCase()}`;
  //         map[key] = item;
  //       }
  //       return map;
  //     }, {});

  //     const key = `${value}_${cityUpper}`; // Use uppercase city in key
  //     const stateObj = lookupMap[key];
  //     return stateObj?.state;
  //   } else if (country === 'IN' && (city === "" || city == null || city == undefined)) {
  //     const stateObj1 = this.state.find(s => s.value === value);
  //     return stateObj1?.label;
  //   } else {
  //     return value;
  //   }
  // }

  // bankPlantCodeToName(plant_code:string):any{
  //   if(plant_code !=null || plant_code !=undefined){
  //     const bank_name=this.bankPlantNameAndCode.find(b=> b.value === plant_code)
  //     if(bank_name!=null || bank_name!=undefined){
  //       return bank_name.value
  //     }
  //   }
  //   return {}
  // }

  getStateLabel(value: string, country: any): any {
    const stateObj = this.state.find(s => s.value === value);
    if (country === 'IN') {
      return stateObj?.label
    } else {
      return value
    }
  }

  getExpiryYear(year:number): any {
    const obj = this.msmeYearList.find(item => item.year === Number(year));
    if (obj) {
      this.enableMSMEUploadButton=false
    }
    return obj.year;
  }


  get contacts(): FormArray {
    return this.contactForm.get('contacts') as FormArray;
  }

  get rockmancontacts(): FormArray {
    return this.rockmancontactForm.get('rockmancontacts') as FormArray;
  }

  get multipleBank(): FormArray {
    return this.multipleBankDetailForm.get('multipleBank') as FormArray;
  }

  addContact() {
    const contactsArray = this.contactForm.get('contacts') as FormArray;
    const newContact = this.fb.group({
      vm_name: [''],
      telephone: ['',[Validators.pattern(/^\d{10,15}$/)]],
      email_id: ['', [Validators.email]],
      mobile_phone: ['', [Validators.pattern(/^\d{10,15}$/)]],
      is_delete_contact: [''],
    });

    contactsArray.push(newContact);
    this.noContacts = false;
  }

  removeContact(index: number) {
    const contactsArray = this.contactForm.get('contacts') as FormArray;
    // contactsArray.removeAt(index);
    if (contactsArray.length > 1) {
      const contact = contactsArray.at(index);
      if(contact){
        contact.get('is_delete_contact')?.setValue('X'); // Set "X" to is_delete_bank field
        this.deleted_contact_list.push(contact.value);
      }
      contactsArray.removeAt(index);
    }
    this.noContacts = contactsArray.length === 0;
  }

  addMultipleBankDetail() {
    const multipleBankDetailForm = this.multipleBankDetailForm.get('multipleBank') as FormArray;

    if (multipleBankDetailForm.length > 0) {
      const lastBankDetail = multipleBankDetailForm.at(multipleBankDetailForm.length - 1);

      // Validate the last bank detail form
      if (lastBankDetail.invalid) {
        lastBankDetail.markAllAsTouched();  // Highlight invalid fields
        this.messageService.add({
          severity: 'warn',
          summary: 'Warning',
          detail: 'Please fill all required fields before adding a new bank detail.'
        });
        return;  // Stop if the last form is invalid
      }
    }
    const newbank = this.fb.group({
      account_holder__registered_name: ['', Validators.required],
      account_no: ['', [Validators.required, this.noSpecialCharactersValidator]],
      bank_name: ['', Validators.required],
      plant_code: ['', Validators.required],
      // bank_address: ['', Validators.required],
      ifsc_code: ['', [Validators.required]],
      cancelled_cheque: [''],
      branch_name: ['', Validators.required],
      is_delete_bank: [''],
      // bank_city: ['', Validators.required], // Add bank_city here
      // bank_region: ['', Validators.required], // Add bank_region here
    });

    multipleBankDetailForm.push(newbank);

    // this.isBankChange=true
  }

  validatePlantCode(currentIndex: number, plantCode: string): boolean {
    const multipleBank = this.multipleBankDetailForm.get('multipleBank') as FormArray;
    return multipleBank.controls.some((control, index) => {
      return index !== currentIndex && control.get('plant_code')?.value === plantCode;
    });
  }
  
  onPlantCodeChange(event: any, index: number) {
    const selectedPlantCode = event.value;
    const multipleBank = this.multipleBankDetailForm.get('multipleBank') as FormArray;
    const control = multipleBank.at(index).get('plant_code');

    if (selectedPlantCode && this.validatePlantCode(index, selectedPlantCode)) {
      if (control) {
        control.setErrors({ duplicatePlant: true });
      }
    } else {
      if (control) {
        control.setErrors(null);
        // If there are other validators, rerun them
        control.updateValueAndValidity();
      }
    }
  }


  cancelUploadForCancelledCheque(index: number,file_name:string): void {
    const fileName = file_name.split('/').pop()!;
    const index1 = this.bankUploadedFiles.findIndex(file => file.name === fileName);
    const bankFormGroup = this.multipleBank.controls[index] as FormGroup;
    bankFormGroup.patchValue({
      cancelled_cheque: null,  // Remove the file URL
    });
    if (this.bankUploadedFiles && this.bankUploadedFiles[index1]) {
      this.bankUploadedFiles.splice(index1, 1);  // Remove the file at the same index
    }
    this.messageService.add({
      severity: 'info',
      summary: 'Info',
      detail: 'Upload canceled.',
    });
  }


  removeBankDetail(index: number) {
    const multipleBankDetail = this.multipleBankDetailForm.get('multipleBank') as FormArray;

    if (multipleBankDetail.length > 1) {
      const bank = multipleBankDetail.at(index);

      if (bank) {
        bank.get('is_delete_bank')?.setValue('X'); // Set "X" to is_delete_bank field
        this.deleted_multiple_bank_list.push(bank.value); // Push the updated value
      }

      multipleBankDetail.removeAt(index);
    }
  }

  saveAllContacts() {
    if (this.contactForm) {
      const contacts = this.contactForm.value.contacts;

    } else {
      console.error('Invalid contact data. Cannot save or update');
      this.messageService.add({ severity: 'error', summary: this.content, detail: 'Invalid contact data. Cannot save or update' });
    }
  }

  addRockmanContact() {
    const rockmancontactsArray = this.rockmancontactForm.get('rockmancontacts') as FormArray;
    const newRockmanContact = this.fb.group({
      first_name: [''],
      last_name: [''],
      rockman_contact_department: [''],
      rockman_contact_function: [''],
      is_delete_person: [''],
    });

    rockmancontactsArray.push(newRockmanContact);
    this.noRockmanContacts = false;
  }

  removeRockmanContact(index: number) {
    const rockmancontactsArray = this.rockmancontactForm.get('rockmancontacts') as FormArray;
    // rockmancontactsArray.removeAt(index);
    if (rockmancontactsArray.length > 1) {
      const rock = rockmancontactsArray.at(index);
      if (rock) {
        rock.get('is_delete_person')?.setValue('X'); // Set "X" to is_delete_bank field
        this.deleted_contact_person_list.push(rock.value); // Push the updated value
      }
      rockmancontactsArray.removeAt(index);
    }
    this.noRockmanContacts = rockmancontactsArray.length === 0;
  }

  noSpecialCharactersValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const regex = /^[a-zA-Z0-9]+$/; // Regex to allow only alphanumeric characters

      if (control.value && !regex.test(control.value)) {
        return { 'specialCharacters': true };
      }

      return null;
    };
  }
  downloadFile(url: string, fileName: string): void {
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement('a');

        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(error => console.error('Error downloading file:', error));
  }

  downloadFileForBanks(index: number, fileName: string): void {
    const data = this.patchBankUploaded[index]
    if(data && data.cancelled_cheque){
      fetch(data.cancelled_cheque)
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement('a');

        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(error => console.error('Error downloading file:', error));
    }
  }


  // downloadEvaluationSheetFormat () {
  //   this.router.navigate("http://127.0.0.1:8000/files/evaluation_sheet_format.xlsx")=
  // }

  panValidator(control: AbstractControl): ValidationErrors | null {
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

    if (control.value && !panRegex.test(control.value)) {
      return { invalidPan: true };
    }

    return null;
  }

  gstnValidator(control: AbstractControl): ValidationErrors | null {
    const gstnRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[A-Z]{1}[0-9A-Z]{1}$/;

    if (control.value && !gstnRegex.test(control.value)) {
      return { invalidGstn: true };
    }

    return null;
  }

  onGstnInput(event: KeyboardEvent): void {
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight','Tab'];
    const allowedCharacters = /^[0-9A-Z]$/i; // Regex for allowing digits (0-9) and letters (A-Z) case insensitive

    if (!allowedKeys.includes(event.key) && !allowedCharacters.test(event.key)) {
      event.preventDefault();
      return;
    }

    const input = event.target as HTMLInputElement;
    if (input.value.length >= 15 && event.key !== 'Backspace' && event.key !== 'Tab' && event.key !== 'Delete' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
      event.preventDefault();
    }
  }
  onPanNoInput(event: KeyboardEvent): void {
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight','Tab'];
    const allowedCharacters = /^[0-9A-Z]$/i; // Regex for allowing digits (0-9) and letters (A-Z) case insensitive

    if (!allowedKeys.includes(event.key) && !allowedCharacters.test(event.key)) {
      event.preventDefault();
      return;
    }

    const input = event.target as HTMLInputElement;
    if (input.value.length >= 10 && event.key !== 'Backspace' && event.key !== 'Tab' && event.key !== 'Delete' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
      event.preventDefault();
    }
  }



  validatePostalCode(event: KeyboardEvent) {
    const key = event.key;
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight','Tab'];
    const isNumeric = /[0-9]/.test(key);

    if (!isNumeric && !allowedKeys.includes(key)) {
      event.preventDefault();
    }

    // Limit to 6 digits
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue.length >= 6 && !allowedKeys.includes(key)) {
      event.preventDefault();
    }
  }

  validateIFSCCode(event: KeyboardEvent) {
    // Get the current value of the input field
    const key = event.key;
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight','Tab'];
    const allowedCharacters = /^[0-9A-Z]$/i; // Regex for allowing digits (0-9) and letters (A-Z) case insensitive


    if (!allowedCharacters && !allowedKeys.includes(key)) {
      event.preventDefault();
    }

    // Limit to 11 digits
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue.length >= 15 && !allowedKeys.includes(key)) {
      event.preventDefault();
    }
  }


  updateMobileNoCode(event: any) {
    if (event.value) {
      this.registrationForm
        .get('primary_address')
        ?.get('contact_person')
        ?.patchValue({
          mobile_no: event.value,
        });
    }
  }
  validateAadharNumber(event: KeyboardEvent) {
    const key = event.key;
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight','Tab'];
    const isNumeric = /[0-9]/.test(key);

    if (!isNumeric && !allowedKeys.includes(key)) {
      event.preventDefault();
    }

    // Limit to 12 digits
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue.length >= 12 && !allowedKeys.includes(key)) {
      event.preventDefault();
    }
  }
  validateIfcsCode(event: KeyboardEvent) {
    const key = event.key;
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'];
    const isNumeric = /[0-9]/.test(key);

    if (!isNumeric && !allowedKeys.includes(key)) {
      event.preventDefault();
    }

    // Limit to 12 digits
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue.length >= 12 && !allowedKeys.includes(key)) {
      event.preventDefault();
    }
  }
  validateForTelephoneAndMobile(event: KeyboardEvent) {
    const key = event.key;
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight','Tab'];
    const isNumeric = /[0-9]/.test(key);

    // Check if Ctrl (or Cmd) is pressed along with allowed keys like a, c, v, x
    const isCtrlCmdPressed = event.ctrlKey || event.metaKey;
    const allowedCtrlCmdKeys = ['a', 'c', 'v', 'x'];

    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value;

    // Prevent input if length is 15 or more and the key is not allowed
    if (inputValue.length >= 15 && !allowedKeys.includes(key) && !(isCtrlCmdPressed && allowedCtrlCmdKeys.includes(key.toLowerCase()))) {
        event.preventDefault();
        return; // Prevent any further processing if max length reached
    }

    if (
        isNumeric ||
        allowedKeys.includes(key) ||
        (isCtrlCmdPressed && allowedCtrlCmdKeys.includes(key.toLowerCase()))
    ) {
        return; // Allow the key event
    }

    event.preventDefault(); // Prevent any other input
}

  get panNumber() {
    return this.registrationForm.get('pan_no');
  }
  get gstnNumber() {
    return this.registrationForm.get(
      'primary_address.tax_details.gstn'
    );
  }

  get vendorCode() {
    return this.registrationForm.get('vendor_code')!;
  }

  onActiveIndexChange(event: number) {
    this.activeIndex = event;
  }

  setGSTNValidation() {
    const gstnControl = this.registrationForm.get(
      'primary_address.tax_details.gstn'
    );
    if (this.isGSTRegistered()) {
      gstnControl?.setValidators([Validators.required]);
    } else {
      gstnControl?.clearValidators();
    }
    gstnControl?.updateValueAndValidity();
  }

  isCountryIndia(country: string | null): boolean {
    if (!country) return false;
    const lowercaseCountry = country.toLowerCase();
    return ['india', 'in', 'ind'].includes(lowercaseCountry);
  }

  next() {
    if (this.activeIndex < this.items.length - 1) {
      this.activeIndex++;
    }
  }

  prev() {
    if (this.activeIndex > 0) {
      this.activeIndex--;
    }
  }

  emailMatchValidator(formGroup: FormGroup): ValidationErrors | null {
    const e_mail_id = formGroup.get(
      'primary_address.contact_person.e_mail_id'
    )?.value;
    const alternate_email_id = formGroup.get(
      'primary_address.contact_person.alternate_email_id'
    )?.value;
    const primaryAddressEmail = formGroup.get(
      'primary_address.email_address'
    )?.value;

    // if (e_mail_id && !(e_mail_id === primaryAddressEmail || e_mail_id === alternate_email_id)) {
    //   return { emailMatch: true };
    // }
    // else if (alternate_email_id && alternate_email_id === primaryAddressEmail) {
    //   return { emailMatch: true };
    // }
    // else {
    //   return null;
    // }
    if (primaryAddressEmail && primaryAddressEmail === e_mail_id) {
      return { emailMatch1: true, emailMatch: true };
    } else if (e_mail_id && e_mail_id === alternate_email_id) {
      return { emailMatch2: true, emailMatch1: true };
    } else if (
      alternate_email_id &&
      alternate_email_id === primaryAddressEmail
    ) {
      return { emailMatch: true, emailMatch2: true };
    } else {
      return null;
    }
  }

  onVendorImageUpload($event: any) {
    if ($event.files && $event.files.length > 0) {
      const file = $event.files[0];
      this.vendorImageFile = file;
      this.vendorImageFile = $event.files[0];

      const fileUrl = `/private/files/${this.vendorImageFile?.name}`;

      this.registrationForm.patchValue({
        propertiery_img: fileUrl,
      });
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Vendor Image uploaded successfully',
      });
    } else {
      console.error('Please select an MSME certificate.');
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select an Vendor Image.',
      });
    }
  }

  onUploadFile($event: any, type: string) {
    if ($event.files && $event.files.length > 0) {
      const file = $event.files[0];
      const fileUrl = `/private/files/${file.name}`;
      if (type === 'other_documents') {
        this.otherDocumentsFiles = file;
      } else if (type === 'upload_cin') {
        this.uploadCIN = file;
      } else if (type === 'pan_document') {
        this.panDocument = file;
      }
      else if (type === 'msme_certificate') {
        this.msmeCertificateFile = file;
      } else if (type === 'company_registration') {
        this.companyRegistrationFile = file;
      } else if (type === 'upload_gst') {
        this.uploadGstFile = file;
        this.registrationForm.get('primary_address.tax_details')?.patchValue({
          [type]: fileUrl,
        });
      } else if (type === 'cancelled_cheque') {
        this.cancelledCheque = file;
        this.registrationForm.get('primary_address.bank_detail')?.patchValue({
          [type]: fileUrl,
        });
      }
      this.registrationForm.patchValue({
        [type]: fileUrl,
      });

      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: `${type} uploaded successfully`,
      });
    } else {
      console.error(`Please select a ${type}.`);
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: `Please select a ${type}.`,
      });
    }
  }

  isGSTRegistered(): boolean {
    return this.registrationForm.get('gst_registered')?.value === 'Yes';
  }

  ismca(): boolean {
    return (
      this.registrationForm.get('ministry_of_corporate_affairsmca')?.value ===
      'Yes'
    );
  }

  onUploadFileForCancelledCheque($event: any, type: string, index: number) {
    if ($event.files && $event.files.length > 0) {
      const file = $event.files[0];
      const fileUrl = `/private/files/${file.name}`;


      // Get the bank's form group in the FormArray
      const bankFormGroup = this.multipleBank.controls[index] as FormGroup;

      if (type === 'cancelled_cheque') {
        // Update the cancelled_cheque field for the specific bank
        bankFormGroup.patchValue({
          cancelled_cheque: fileUrl,
        });

        this.bankUploadedFiles.push(file);
      }

      // Other file types can be handled similarly, if necessary

      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: `${type} uploaded successfully`,
      });
    } else {
      console.error(`Please select a ${type}.`);
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: `Please select a ${type}.`,
      });
    }
  }

  mcaUpload($event: any) {
    if ($event.files && $event.files.length > 0) {
      const file = $event.files[0];
      this.mcaDocument = file;
      this.mcaDocument = $event.files[0];
      const fileUrl = `/private/files/${this.mcaDocument?.name}`;

      this.registrationForm.patchValue({
        mca_document: fileUrl,
      });
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'MCA Document uploaded successfully',
      });
    } else {
      console.error('please select MCA Document');
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select MCA Document.',
      });
    }
  }
  panUpload($event: any, type: string) {
    if ($event.files && $event.files.length > 0) {
      const file = $event.files[0];
      this.panDocument = file;
      this.panDocument = $event.files[0];
      const fileUrl = `/private/files/${this.panDocument?.name}`;

      this.registrationForm.patchValue({
        pan_document: fileUrl,
      });
      this.registrationForm.patchValue({
        [type]: fileUrl,
      });
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'PAN Document uploaded successfully',
      });
    } else {
      console.error('please select PAN Document');
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select PAN Document.',
      });
    }
  }
  selfDeclarationByVendorUpload($event: any) {
    if ($event.files && $event.files.length > 0) {
      const file = $event.files[0];
      this.selfDeclarationByVendor = file;
      this.selfDeclarationByVendor = $event.files[0];
      const fileUrl = `/private/files/${this.selfDeclarationByVendor?.name}`;

      this.registrationForm.patchValue({
        self_declaration_by_vendor: fileUrl,
      });
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Self Declaration By Vendor uploaded successfully',
      });
    } else {
      console.error('please select company registration');
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select Self Declaration By Vendor.',
      });
    }
  }
  evaluationSheetUpload($event: any) {
    if ($event.files && $event.files.length > 0) {
      const file = $event.files[0];
      this.evaluationSheet = file;
      this.evaluationSheet = $event.files[0];
      const fileUrl = `/private/files/${this.evaluationSheet?.name}`;

      this.registrationForm.patchValue({
        evaluation_sheet: fileUrl,
      });
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Evaluation Sheet uploaded successfully',
      });
    } else {
      console.error('please select company registration');
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select Evaluation Sheet.',
      });
    }
  }
  document1Upload($event: any) {
    if ($event.files && $event.files.length > 0) {
      const file = $event.files[0];
      this.document1 = file;
      this.document1 = $event.files[0];
      const fileUrl = `/private/files/${this.document1?.name}`;

      this.registrationForm.patchValue({
        document_1: fileUrl,
      });
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Company Profile uploaded successfully',
      });
    } else {
      console.error('please select Company Profile');
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select Company Profile.',
      });
    }
  }
  document2Upload($event: any) {
    if ($event.files && $event.files.length > 0) {
      const file = $event.files[0];
      this.document2 = file;
      this.document2 = $event.files[0];
      const fileUrl = `/private/files/${this.document2?.name}`;

      this.registrationForm.patchValue({
        document_2: fileUrl,
      });
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Balance Sheet uploaded successfully',
      });
    } else {
      console.error('please select Balance Sheet');
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select Balance Sheet.',
      });
    }
  }
  document3Upload($event: any) {
    if ($event.files && $event.files.length > 0) {
      const file = $event.files[0];
      this.document3 = file;
      this.document3 = $event.files[0];
      const fileUrl = `/private/files/${this.document3?.name}`;

      this.registrationForm.patchValue({
        document_3: fileUrl,
      });
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Auditor Report  uploaded successfully',
      });
    } else {
      console.error('please select Auditor Report');
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select Auditor Report.',
      });
    }
  }
  document4Upload($event: any) {
    if ($event.files && $event.files.length > 0) {
      const file = $event.files[0];
      this.document4 = file;
      this.document4 = $event.files[0];
      const fileUrl = `/private/files/${this.document4?.name}`;

      this.registrationForm.patchValue({
        document_4: fileUrl,
      });
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'ISO Certificate uploaded successfully',
      });
    } else {
      console.error('please select ISO Certificate');
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select ISO Certificate.',
      });
    }
  }
  document5Upload($event: any) {
    if ($event.files && $event.files.length > 0) {
      const file = $event.files[0];
      this.document5 = file;
      this.document5 = $event.files[0];
      const fileUrl = `/private/files/${this.document5?.name}`;

      this.registrationForm.patchValue({
        document_5: fileUrl,
      });
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'List Of Equipment uploaded successfully',
      });
    } else {
      console.error('please select List Of Equipment');
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select List Of Equipment.',
      });
    }
  }
  document6Upload($event: any) {
    if ($event.files && $event.files.length > 0) {
      const file = $event.files[0];
      this.document6 = file;
      this.document6 = $event.files[0];
      const fileUrl = `/private/files/${this.document6?.name}`;

      this.registrationForm.patchValue({
        document_6: fileUrl,
      });
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Other Document  uploaded successfully',
      });
    } else {
      console.error('please select Other Document');
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select Other Document.',
      });
    }
  }
  getLoggedInUser() {
    this.authService
      .getLoggedInUser()
      .then((user) => {
        this.loggedInUser = user;
      })
      .catch((error) => {
        console.error('Error fetching logged-in user:', error);
      });
  }

  validateNumber(event: KeyboardEvent) {
    const inputElement = event.target as HTMLInputElement;

    // Allow control keys and navigation keys
    if (
      !/[a-zA-Z0-9]/.test(event.key) &&
      !event.ctrlKey &&
      !['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(
        event.key
      )
    ) {
      event.preventDefault();
    }

    // Prevent input if length exceeds 20 digits
    if (/[a-zA-Z0-9]/.test(event.key) && inputElement.value.length >= 18 &&
    !['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(
      event.key
    )) {
      event.preventDefault();
    }
  }

  getPlantList() {
    this.shipment_asn
      .getPlantList()
      .then((res: any[]) => {
        // this.plantList = res;
        res.forEach((data)=>{
          let plant:PlantWithCode = {
            plant__code:data.plant__code,
            name1: `${data.plant__code}-${data.name1}`
          }
          this.plantList.push(plant)
        })
        this.fetchVendorDetails()
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  onCheckbox(event: any) {
  }

  // disableSubmit: boolean = false;

  // submitForm() {
  //   // const checkbox = this.registrationForm.get('note');
  //   // if (checkbox) {
  //   //   if (checkbox.value === true) {
  //   //     this.disableSubmit = checkbox.value;
  //   //     console.log(this.disableSubmit);
  //   //   }
  //   // }
  // const plantControl = this.registrationForm.get('plant');
  // if (plantControl) {
  //   if (plantControl.value) {
  //     plantControl.setValue(plantControl.value.name);
  //   }
  // } else {
  //   console.error("'plant' control does not exist in the form.");
  // }
  // console.log(this.registrationForm.value);
  // }

  hideCity: boolean = false

  onStateChange(selectedValue: any) {
    if (selectedValue === "IN") {
      this.hideCity = true
    } else {
      this.registrationForm.get('primary_address.city')?.setValue(null)
      this.registrationForm.get('primary_address.state')?.setValue(null)
      this.hideCity = false
    }
  }
  onCityChange(selectedValue: any) {
    if (selectedValue != null) {
      this.registrationForm.get('primary_address.state')?.setValue(selectedValue.state)
    }
  }

mergeDeep(target: any, source: any): string[] {
  const differingKeys: string[] = [];
  this.summaryValue =[]


  const compare = (t: any, s: any, path: string = ''): void => {
    const keys = new Set([...Object.keys(t), ...Object.keys(s)]);

    for (const key of keys) {
      const tValue = t[key];
      const sValue = s[key];
      const currentPath = path ? `${path}.${key}` : key;

      if (typeof tValue === 'object' && typeof sValue === 'object' && tValue !== null && sValue !== null) {
        compare(tValue, sValue, currentPath);
      } else if (tValue != sValue) {
        differingKeys.push(currentPath);
        let summaryData:SummaryData = {
          key:currentPath,
          oldValue:sValue,
          newValue:tValue
        }
        this.summaryValue.push(summaryData)
      } else if ((tValue && typeof tValue === 'object') || (sValue && typeof sValue === 'object')) {
        differingKeys.push(currentPath);
      }
    }
  }

  compare(target, source);
  return differingKeys;
}


  submitForm() {
    const primaryDetailsFormGroup = this.registrationForm.get('primary_address') as FormGroup;
    // if (primaryDetailsFormGroup.get('state')?.value) {
    //   const state = primaryDetailsFormGroup.get('state')?.value
    //   if (state.value) {
    //     primaryDetailsFormGroup.get('state')?.setValue(state.value)
    //     primaryDetailsFormGroup.get('state1')?.setValue(state.label)
    //   } else {
    //     primaryDetailsFormGroup.get('state')?.setValue(state)
    //   }
    // }
    const stateValue = primaryDetailsFormGroup.get('state')?.value;
    const plantValue = this.registrationForm.get('plant')?.value;

    let city1data1 = this.registrationForm.get('primary_address.city')?.value
    let city_name_city=city1data1
    if(city1data1 != null || city1data1 != undefined){
      if (city1data1.city != this.formValues.primary_address.city.city) {
        this.registrationForm.get('primary_address.city')?.setValue(city1data1.city)
      } else {
        this.registrationForm.get('primary_address.city')?.setValue(city1data1)
      }
    }

    const newRockmanContactDetail = this.rockmancontactForm.value.rockmancontacts;
    const newRockmanContactDetailControl = this.registrationForm.get("new_rockman_contact_detail");
    if (newRockmanContactDetailControl && newRockmanContactDetail.length > 0) {
      if (newRockmanContactDetail[0].first_name != "" && newRockmanContactDetail[0].last_name != "" && newRockmanContactDetail[0].rockman_contact_department != "" && newRockmanContactDetail[0].rockman_contact_function != ""){
        const updatedPersionDetails = [...newRockmanContactDetail, ...this.deleted_contact_person_list];
        newRockmanContactDetailControl.setValue(updatedPersionDetails);
      }
    }

    // const multipleBankDetailForm = this.multipleBankDetailForm.value.multipleBank;
    // const multiple_bank_detail = this.registrationForm.get("primary_address.multiple_bank_detail");
    // if (multiple_bank_detail) {
    //   multiple_bank_detail.setValue(multipleBankDetailForm);
    // }

    const multipleBankDetailFormArray = this.multipleBank;
    const multipleBankDetails = this.multipleBankDetailForm.value.multipleBank;
    const multipleBankDetailControl = this.registrationForm.get("primary_address.multiple_bank_detail");

    if (multipleBankDetailControl) {
      if (multipleBankDetailFormArray.valid) {
        const updatedBankDetails = [...multipleBankDetails, ...this.deleted_multiple_bank_list];
        multipleBankDetailControl.setValue(updatedBankDetails);
      } else {
        this.compileMissingFields(multipleBankDetails);
      }
    }


    const newContactDetail = this.contactForm.value.contacts;
    const newVmContactDetailControl = this.registrationForm.get("new_vm_contact_detail");

    // if (newVmContactDetailControl) {
    //   newVmContactDetailControl.setValue(newContactDetail);
    // }

    if (newVmContactDetailControl && newContactDetail.length > 0) {
      if (newContactDetail[0].mobile_phone != "" && newContactDetail[0].email_id != ""){
        const updatedContactDetails = [...newContactDetail, ...this.deleted_contact_list];
        newVmContactDetailControl.setValue(updatedContactDetails);
        const newVmContactDetailValue = newVmContactDetailControl.value;


      if (newVmContactDetailValue && newVmContactDetailValue.length > 0) {
        const firstContactDetail = newVmContactDetailValue[0];

        // const primaryDetailsFormGroup = this.registrationForm.get('primary_address') as FormGroup;

        // if (primaryDetailsFormGroup.get('state')?.value) {
        //   const state = primaryDetailsFormGroup.get('state')?.value
        //   primaryDetailsFormGroup.get('state')?.setValue(state.value)
        //   primaryDetailsFormGroup.get('state1')?.setValue(state.label)
        // }
        if (primaryDetailsFormGroup) {
          const contactPersonFormGroup = primaryDetailsFormGroup.get('contact_person') as FormGroup;

          if (contactPersonFormGroup) {
            contactPersonFormGroup.patchValue({
              name1: firstContactDetail.vm_name,
              e_mail_id: firstContactDetail.email_id,
              phone_no: firstContactDetail.telephone,
              mobile_no: firstContactDetail.mobile_phone,
            });
          } else {
            console.error("'contact_person' control does not exist in the form.");
          }
        } else {
          console.error("'primary_details' control does not exist in the form.");
        }
      }
    }

    }

    const plantControl = this.registrationForm.get('plant');
    if (plantControl) {
      if (plantControl.value) {
        plantControl.setValue(plantControl.value);
      }
    } else {
      console.error("'plant' control does not exist in the form.");
    }
    this.missingFields = [];
    const businessNameControl = this.registrationForm.get('business_name');
    const businessName = businessNameControl ? businessNameControl.value : null;
    // const action = isSave ? 'save' : 'submit';
    // const status = isSave ? 'Draft' : 'PENDING_REVIEW';
    // this.registrationForm.patchValue({ status });
    // if (isSave && !businessName) {
    //   this.missingFields.push('Business Name is required for saving.');
    //   this.registrationForm.get('business_name')?.setErrors({ required: true });
    //   this.registrationForm.markAllAsTouched();
    //   this.displayDialog = true;
    //   this.messageService.add({
    //     severity: 'error',
    //     summary: 'Error',
    //     detail: 'Business Name is required for saving.',
    //   });
    //   if (stateValue) {
    //     primaryDetailsFormGroup.get('state')?.setValue(stateValue);
    //     primaryDetailsFormGroup.get('state1')?.setValue(stateValue.label);
    //   }
    //   if (plantValue) {
    //     this.registrationForm.get('plant')?.setValue(plantValue);
    //   }
    //   return;
    // }
    let statefinal:any
    if (this.registrationForm.valid) {
      this.isLoading = true
      this.registrationForm.value.get_user = this.loggedInUser;
      this.registrationForm.value.financial_previous_year =
        this.financialPreviousYear;
      this.registrationForm.value.financial_one_year_before_previous_year =
        this.financialOneYearBeforePreviousYear;
      this.registrationForm.value.financial_two_years_before_previous_year =
        this.financialtwoYearsBeforePreviousYear;
      const mergedData = this.mergeDeep(this.registrationForm.value, this.formValues);
      // const differencesString = mergedData.join(', ');
      const differencesString = JSON.stringify(this.summaryValue);
      if (this.summaryValue.length > 0 && !this.isBankChange) {
        for (const data of this.summaryValue) {
          if (data.key.startsWith("primary_address.multiple_bank_detail")) {
            this.isBankChange = true;
            break;
          }
        }
      }

      const city1data = this.registrationForm.get('primary_address.city')?.value
        if (city1data.city) {
          this.registrationForm.get('primary_address.city')?.setValue(city1data.city)
        } else {
          this.registrationForm.get('primary_address.city')?.setValue(city1data)
        }
      const state1 = this.registrationForm.get('primary_address.state')?.value
      const citycuuurrect = this.registrationForm.get('primary_address.city')?.value
      if (state1) {
        const state2=this.state.find((state)=> state.label == state1)
        statefinal=state2
        if (state2) {
          this.registrationForm.get('primary_address.state')?.setValue(state2?.value)
          this.registrationForm.get('primary_address.state1')?.setValue(state2?.value)
        }
      }
      this.registrationForm.value.highlights_detail=differencesString
      const data = {
        data: this.registrationForm.value,
        get_user: this.registrationForm.value.get_user,
        is_bank_change: this.isBankChange
      };
      const uploadPromises = [];
      if (this.msmeCertificateFile) {
        const msmeArgs = {
          is_private: '1',
          folder: 'Home',
          file_url: `/private/files/${this.msmeCertificateFile.name}`,
          doctype: 'Vendor Master',
          docname: this.registrationForm.value.business_name,
          fieldname: 'msme_certificate',
        };
        const path = `${this.FRAPPE_API_URL}/api/method/upload_file`;
        uploadPromises.push(
          this.vendorService
            .uploadFile(path, this.msmeCertificateFile, msmeArgs)
            .toPromise()
        );
      }
      if (this.mcaDocument) {
        const msmeArgs = {
          is_private: '1',
          folder: 'Home',
          file_url: `/private/files/${this.mcaDocument.name}`,
          doctype: 'Vendor Master',
          docname: this.registrationForm.value.business_name,
          fieldname: 'mca_document',
        };
        const path = `${this.FRAPPE_API_URL}/api/method/upload_file`;
        uploadPromises.push(
          this.vendorService
            .uploadFile(path, this.mcaDocument, msmeArgs)
            .toPromise()
        );
      }
      if (this.panDocument) {
        const msmeArgs = {
          is_private: '1',
          folder: 'Home',
          file_url: `/private/files/${this.panDocument.name}`,
          doctype: 'Vendor Master',
          docname: this.registrationForm.value.business_name,
          fieldname: 'pan_document',
        };
        const path = `${this.FRAPPE_API_URL}/api/method/upload_file`;
        uploadPromises.push(
          this.vendorService
            .uploadFile(path, this.panDocument, msmeArgs)
            .toPromise()
        );
      }
      if (this.companyRegistrationFile) {
        const companyRegistration = {
          is_private: '1',
          folder: 'Home',
          file_url: `/private/files/${this.companyRegistrationFile.name}`,
          doctype: 'Vendor Master',
          docname: this.registrationForm.value.business_name,
          fieldname: 'company_registration',
        };
        const path = `${this.FRAPPE_API_URL}/api/method/upload_file`;
        uploadPromises.push(
          this.vendorService
            .uploadFile(path, this.companyRegistrationFile, companyRegistration)
            .toPromise()
        );
      }
      if (this.otherDocumentsFiles) {
        const otherDocumentsUploadDetails = {
          is_private: '1',
          folder: 'Home',
          file_url: `/private/files/${this.otherDocumentsFiles.name}`,
          doctype: 'Vendor Master',
          docname: this.registrationForm.value.business_name,
          fieldname: 'other_documents',
        };
        const path = `${this.FRAPPE_API_URL}/api/method/upload_file`;
        uploadPromises.push(
          this.vendorService
            .uploadFile(
              path,
              this.otherDocumentsFiles,
              otherDocumentsUploadDetails
            )
            .toPromise()
        );
      }
      if (this.vendorImageFile) {
        const vendorimageUploadDetails = {
          is_private: '1',
          folder: 'Home',
          file_url: `/private/files/${this.vendorImageFile.name}`,
          doctype: 'Vendor Master',
          docname: this.registrationForm.value.business_name,
          fieldname: 'propertiery_img',
        };
        const path = `${this.FRAPPE_API_URL}/api/method/upload_file`;
        uploadPromises.push(
          this.vendorService
            .uploadFile(path, this.vendorImageFile, vendorimageUploadDetails)
            .toPromise()
        );
      }
      if (this.uploadCIN) {
        const uploadCIN = {
          is_private: '1',
          folder: 'Home',
          file_url: `/private/files/${this.uploadCIN.name}`,
          doctype: 'Vendor Master',
          docname: this.registrationForm.value.business_name,
          fieldname: 'upload_cin',
        };
        const path = `${this.FRAPPE_API_URL}/api/method/upload_file`;
        uploadPromises.push(
          this.vendorService
            .uploadFile(path, this.uploadCIN, uploadCIN)
            .toPromise()
        );
      }
      if (this.uploadGstFile) {
        const uploadGstFile = {
          is_private: '1',
          folder: 'Home',
          file_url: `/private/files/${this.uploadGstFile.name}`,
          doctype: 'Vendor Master',
          docname: this.registrationForm.value.business_name,
          fieldname: 'upload_gst',
        };
        const path = `${this.FRAPPE_API_URL}/api/method/upload_file`;
        uploadPromises.push(
          this.vendorService
            .uploadFile(path, this.uploadGstFile, uploadGstFile)
            .toPromise()
        );
      }
      for (let i = 0; i < this.bankUploadedFiles.length; i++) {
        const file = this.bankUploadedFiles[i];
        // If the cancelled_cheque field has a value (i.e., a file was uploaded)
        if (file) {
          const cancelledCheque = {
            is_private: '1',
            folder: 'Home',
            file_url:`/private/files/${file.name}`,
            doctype: 'Vendor Master',
            docname: this.registrationForm.value.business_name,
            fieldname: 'cancelled_cheque',
          };
          const path = `${this.FRAPPE_API_URL}/api/method/upload_file`;
          uploadPromises.push(
            this.vendorService.uploadFile(path, file, cancelledCheque).toPromise()
          );
        }
      }
      if (this.selfDeclarationByVendor) {
        const selfDeclarationByVendorUpload = {
          is_private: '1',
          folder: 'Home',
          file_url: `/private/files/${this.selfDeclarationByVendor.name}`,
          doctype: 'Vendor Master',
          docname: this.registrationForm.value.business_name,
          fieldname: 'self_declaration_by_vendor',
        };
        const path = `${this.FRAPPE_API_URL}/api/method/upload_file`;
        uploadPromises.push(
          this.vendorService
            .uploadFile(
              path,
              this.selfDeclarationByVendor,
              selfDeclarationByVendorUpload
            )
            .toPromise()
        );
      }
      if (this.evaluationSheet) {
        const evaluationSheetUpload = {
          is_private: '1',
          folder: 'Home',
          file_url: `/private/files/${this.evaluationSheet.name}`,
          doctype: 'Vendor Master',
          docname: this.registrationForm.value.business_name,
          fieldname: 'evaluation_sheet',
        };
        const path = `${this.FRAPPE_API_URL}/api/method/upload_file`;
        uploadPromises.push(
          this.vendorService
            .uploadFile(path, this.evaluationSheet, evaluationSheetUpload)
            .toPromise()
        );
      }
      if (this.document1) {
        const document1Upload = {
          is_private: '1',
          folder: 'Home',
          file_url: `/private/files/${this.document1.name}`,
          doctype: 'Vendor Master',
          docname: this.registrationForm.value.business_name,
          fieldname: 'document_1',
        };
        const path = `${this.FRAPPE_API_URL}/api/method/upload_file`;
        uploadPromises.push(
          this.vendorService
            .uploadFile(path, this.document1, document1Upload)
            .toPromise()
        );
      }
      if (this.document2) {
        const document2Upload = {
          is_private: '1',
          folder: 'Home',
          file_url: `/private/files/${this.document2.name}`,
          doctype: 'Vendor Master',
          docname: this.registrationForm.value.business_name,
          fieldname: 'document_2',
        };
        const path = `${this.FRAPPE_API_URL}/api/method/upload_file`;
        uploadPromises.push(
          this.vendorService
            .uploadFile(path, this.document2, document2Upload)
            .toPromise()
        );
      }
      if (this.document3) {
        const document3Upload = {
          is_private: '1',
          folder: 'Home',
          file_url: `/private/files/${this.document3.name}`,
          doctype: 'Vendor Master',
          docname: this.registrationForm.value.business_name,
          fieldname: 'document_3',
        };
        const path = `${this.FRAPPE_API_URL}/api/method/upload_file`;
        uploadPromises.push(
          this.vendorService
            .uploadFile(path, this.document3, document3Upload)
            .toPromise()
        );
      }
      if (this.document4) {
        const document4Upload = {
          is_private: '1',
          folder: 'Home',
          file_url: `/private/files/${this.document4.name}`,
          doctype: 'Vendor Master',
          docname: this.registrationForm.value.business_name,
          fieldname: 'document_4',
        };
        const path = `${this.FRAPPE_API_URL}/api/method/upload_file`;
        uploadPromises.push(
          this.vendorService
            .uploadFile(path, this.document4, document4Upload)
            .toPromise()
        );
      }
      if (this.document5) {
        const document5Upload = {
          is_private: '1',
          folder: 'Home',
          file_url: `/private/files/${this.document5.name}`,
          doctype: 'Vendor Master',
          docname: this.registrationForm.value.business_name,
          fieldname: 'document_5',
        };
        const path = `${this.FRAPPE_API_URL}/api/method/upload_file`;
        uploadPromises.push(
          this.vendorService
            .uploadFile(path, this.document5, document5Upload)
            .toPromise()
        );
      }
      if (this.document6) {
        const document6Upload = {
          is_private: '1',
          folder: 'Home',
          file_url: `/private/files/${this.document6.name}`,
          doctype: 'Vendor Master',
          docname: this.registrationForm.value.business_name,
          fieldname: 'document_6',
        };
        const path = `${this.FRAPPE_API_URL}/api/method/upload_file`;
        uploadPromises.push(
          this.vendorService
            .uploadFile(path, this.document6, document6Upload)
            .toPromise()
        );
      }
      Promise.all(uploadPromises)
        .then((uploadResponses) => {
          console.log('All files uploaded:', uploadResponses);
          // if (action === 'submit') {
            this.vendorService.createVendorChangeRequest(data)
              .then(response => {
                this.isLoading = false
                if (response.message.status == "Failed") {
                  this.messageService.add({ severity: 'error', summary: 'Failed', detail: response.message.message, life: 5000 });
                } else {
                  this.messageService.add({ severity: 'success', summary: 'Success', detail: response.message.message });
                  const navigationExtras: NavigationExtras = {
                    state: {
                      business_name:this.business_name
                    }
                  };
                this.router.navigate(['/pending-vendor-approval'],navigationExtras);
                }
                if (city_name_city.city) {
                  this.registrationForm.get('primary_address.city')?.setValue(city_name_city)
                }
                if (statefinal && statefinal.value) {
                  this.registrationForm.get('primary_address.state')?.setValue(statefinal?.label)
                  this.registrationForm.get('primary_address.state1')?.setValue(statefinal?.label)
                }
              })
              .catch(error => {
                this.isLoading = false
                const friendlyErrorMessage = this.parseGenericErrorMessage(error);
                this.messageService.add({ severity: 'error', summary: 'Error', detail: friendlyErrorMessage });
                console.error("Error updating vendor details:", error);
                // if (stateValue) {
                //   primaryDetailsFormGroup.get('state')?.setValue(stateValue);
                //   primaryDetailsFormGroup.get('state1')?.setValue(stateValue.label);
                // }4
                if (plantValue) {
                  this.registrationForm.get('plant')?.setValue(plantValue);
                }
                if (city_name_city.city) {
                  this.registrationForm.get('primary_address.city')?.setValue(city_name_city)
                }
                if (statefinal && statefinal.value) {
                  this.registrationForm.get('primary_address.state')?.setValue(statefinal?.label)
                  this.registrationForm.get('primary_address.state1')?.setValue(statefinal?.label)
                }

              });
          // }
          // else {
          //   this.isLoading = true
          //   this.vendorService
          //     .createVendorMaster(data)
          //     .then((_response) => {
          //       this.isLoading = false
          //       this.messageService.add({
          //         severity: 'success',
          //         summary: 'Success',
          //         detail: _response.message.message,
          //       });
          //       const userFound = true;
          //       this.userService.setUserFound(userFound);
          //       this.userFoundChange.emit(userFound);
          //       // this.router.navigate(['/']);
          //       this.router.navigate(['/portal/vendor/registration']);
          //       if (stateValue) {
          //         primaryDetailsFormGroup.get('state')?.setValue(stateValue);
          //         primaryDetailsFormGroup.get('state1')?.setValue(stateValue.label);
          //       }
          //       if (plantValue) {
          //         this.registrationForm.get('plant')?.setValue(plantValue);
          //       }
          //     })
          //     .catch((error) => {
          //       this.isLoading = false
          //       console.error('Error in component:', error);
          //       const friendlyErrorMessage = this.parseGenericErrorMessage(error);
          //       this.messageService.add({
          //         severity: 'error',
          //         summary: 'Error',
          //         detail: friendlyErrorMessage,
          //       });
          //       if (stateValue) {
          //         primaryDetailsFormGroup.get('state')?.setValue(stateValue);
          //         primaryDetailsFormGroup.get('state1')?.setValue(stateValue.label);
          //       }
          //       if (plantValue) {
          //         this.registrationForm.get('plant')?.setValue(plantValue);
          //       }
          //     });
          // }
        })
        .catch((error) => {
          this.isLoading = false
          if (plantValue) {
            this.registrationForm.get('plant')?.setValue(plantValue);
          }
          if (city_name_city.city) {
            this.registrationForm.get('primary_address.city')?.setValue(city_name_city)
          }
          if (statefinal && statefinal.value) {
            this.registrationForm.get('primary_address.state')?.setValue(statefinal?.label)
            this.registrationForm.get('primary_address.state1')?.setValue(statefinal?.label)
          }
          console.error('Upload error', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error uploading files.',
          });
        });
    } else {
      if (plantValue) {
        this.registrationForm.get('plant')?.setValue(plantValue);
      }
      if (city_name_city.city) {
        this.registrationForm.get('primary_address.city')?.setValue(city_name_city)
      }
      if (statefinal && statefinal.value) {
        this.registrationForm.get('primary_address.state')?.setValue(statefinal?.label)
        this.registrationForm.get('primary_address.state1')?.setValue(statefinal?.label)
      }

      this.registrationForm.markAllAsTouched();
      this.compileMissingFields(this.registrationForm);

      // const newRockmanContactDetailControl = this.rockmancontactForm.value.rockmancontacts;
      // if (newRockmanContactDetailControl) {
      //   if (newRockmanContactDetailControl[0].first_name == "" || newRockmanContactDetailControl[0].last_name == "" || newRockmanContactDetailControl[0].rockman_contact_department == "" || newRockmanContactDetailControl[0].rockman_contact_function == ""){

      //   }
      // }

      this.rockmancontactForm.markAllAsTouched();
      this.compileMissingFields(this.rockmancontactForm);

      // const newVmContactDetailControl = this.contactForm.value.contacts;
      // if (newVmContactDetailControl) {
      //   if (newContactDetail[0].mobile_phone == "" || newContactDetail[0].email_id == ""){

      //   }
      // }
      this.contactForm.markAllAsTouched();
      this.compileMissingFields(this.contactForm);

      this.multipleBankDetailForm.markAllAsTouched();
      this.compileMissingFields(this.multipleBankDetailForm);

      this.displayDialog = true;
      this.isLoading = false
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please fill in all required fields.',
      });
      // if (stateValue) {
      //   primaryDetailsFormGroup.get('state')?.setValue(stateValue);
      //   primaryDetailsFormGroup.get('state1')?.setValue(stateValue.label);
      // }
      if (plantValue) {
        this.registrationForm.get('plant')?.setValue(plantValue);
      }
    }
  }


  cancelUpload(type: string) {
    if (type === 'other_documents') {
      this.otherDocumentsFiles = null;
      this.registrationForm.patchValue({
        other_documents: '',
      });
    } else if (type === 'upload_cin') {
      this.uploadCIN = null;
      this.registrationForm.patchValue({
        upload_cin: '',
      });
    } else if (type === 'msme_certificate') {
      this.msmeCertificateFile = null;
      this.registrationForm.patchValue({
        msme_certificate: '',
      });
    } else if (type === 'company_registration') {
      this.companyRegistrationFile = null;
      this.registrationForm.patchValue({
        msme_certificate: '',
      });
    } else if (type === 'upload_gst') {
      this.uploadGstFile = null;
      this.registrationForm.get('primary_address.tax_details')?.patchValue({
        upload_gst: '',
      });
    } else if (type === 'cancelled_cheque') {
      this.cancelledCheque = null;
      this.registrationForm.get('primary_address.bank_detail')?.patchValue({
        cancelled_cheque: '',
      });
    }
    else if (type === 'pan_document') {
      this.panDocument = null;
      this.registrationForm.patchValue({
        pan_document: '',
      });
    }
  }
  //   cancelMsmeCertificateUpload() {
  //     this.msmeCertificateFile = null;
  //     this.registrationForm.patchValue({
  //         msme_certificate: ''
  //     });
  // }

  cancelOtherDocumentsUpload() {
    this.otherDocumentsFiles = null;
    this.registrationForm.patchValue({
      other_documents: '',
    });
  }
  cancelMcaDocumentUpload() {
    this.mcaDocument = null;
    this.registrationForm.patchValue({
      mca_document: '',
    });
  }
  cancelPanDocumentUpload() {
    this.panDocument = null;
    this.registrationForm.patchValue({
      pan_document: '',
    });
  }
  cancelVendorImageUpload() {
    this.vendorImageFile = null;
    this.registrationForm.patchValue({
      propertiery_img: '',
    });
  }
  cancelSelfDeclarationByVendorUpload() {
    this.selfDeclarationByVendor = null;
    this.registrationForm.patchValue({
      self_declaration_by_vendor: '',
    });
  }
  cancelEvaluationSheetUpload() {
    this.evaluationSheet = null;
    this.registrationForm.patchValue({
      evaluation_sheet: '',
    });
  }
  cancelDocument1Upload() {
    this.document1 = null;
    this.registrationForm.patchValue({
      document_1: '',
    });
  }
  cancelDocument2Upload() {
    this.document2 = null;
    this.registrationForm.patchValue({
      document_2: '',
    });
  }
  cancelDocument3Upload() {
    this.document3 = null;
    this.registrationForm.patchValue({
      document_3: '',
    });
  }
  cancelDocument4Upload() {
    this.document4 = null;
    this.registrationForm.patchValue({
      document_4: '',
    });
  }
  cancelDocument5Upload() {
    this.document5 = null;
    this.registrationForm.patchValue({
      document_5: '',
    });
  }
  cancelDocument6Upload() {
    this.document6 = null;
    this.registrationForm.patchValue({
      document_6: '',
    });
  }

  parseGenericErrorMessage(errorResponse: any): string {
    try {
      if (errorResponse._server_messages) {
        const serverMessages = JSON.parse(errorResponse._server_messages);
        if (Array.isArray(serverMessages) && serverMessages.length > 0) {
          const firstMessageParsed = JSON.parse(serverMessages[0]);
          if (firstMessageParsed && firstMessageParsed.message) {
            return firstMessageParsed.message;
          }
        }
      }

      const rawErrorMessage = errorResponse.message?.message;
      if (!rawErrorMessage) {
        return 'An unexpected error occurred. Please try again.';
      }

      const regex = /Duplicate entry '([^']*)' for key '([^']*)'/;
      const matches = rawErrorMessage.match(regex);

      if (matches && matches.length === 3) {
        const fieldNameReadable = matches[2].replace(/_/g, ' ').toLowerCase();
        const fieldNameCapitalized = fieldNameReadable.replace(
          /\b[a-z]/g,
          (char: string) => char.toUpperCase()
        );
        return `${fieldNameCapitalized} (Duplicate entry '${matches[1]}') is already in use. Please choose a different one.`;
      } else {
        return (
          rawErrorMessage || 'An unexpected error occurred. Please try again.'
        );
      }
    } catch (error) {
      console.error('Error processing the error message:', error);
      return 'An error occurred while processing the error message. Please try again.';
    }
  }

  compileMissingFields(formGroup: FormGroup | FormArray, path: string = ''): void {
    if (formGroup instanceof FormGroup) {
      Object.keys(formGroup.controls).forEach((key) => {
        const abstractControl = formGroup.get(key);
        if (abstractControl instanceof FormGroup || abstractControl instanceof FormArray) {
          this.compileMissingFields(
            abstractControl,
            path ? `${path}.${key}` : key
          );
        } else if (abstractControl && abstractControl.invalid && abstractControl.errors?.['required']) {
          const fieldPath = path ? `${path}.${key}` : key;
          const fieldLabel = this.fieldLabels[fieldPath] || fieldPath;
          this.missingFields.push(fieldLabel);
        }
      });
    } else if (formGroup instanceof FormArray) {
      formGroup.controls.forEach((arrayControl, index) => {
        this.compileMissingFields(
          arrayControl as FormGroup,
          `${path}[${index}]`
        );
      });
    }
  }

  closeDialog() {
    this.displayDialog = false;
  }

  evaluationSheetFormatDownload2L() {
    const downloadUrl = this.FRAPPE_API_URL_PROD + '/files/Rockman_ Vendor Evaluation Check list_Annexure1.xlsx';
    window.location.href = downloadUrl;
  }

  evaluationSheetFormatDownload5L() {
    const downloadUrl = this.FRAPPE_API_URL_PROD + '/files/Vendor Evaluation Check list  -Annexure-3.xlsx';
    window.location.href = downloadUrl;
  }

  selfDeclarationByVendorFormDownload() {
    const downloadUrl = this.FRAPPE_API_URL_PROD + '/files/Declaration On No Child Labour NO RPT.docx';
    window.location.href = downloadUrl;
  }

  SelectIndustryType1(event: any) {
    const msme_no = this.registrationForm.get('msme_no');
    const msme_certificate = this.registrationForm.get('msme_certificate');
    if (event === '0001' || event === '0002' || event === '0003') {
      // msme_no?.setValidators(Validators.required);
      this.isIndustry = true
    } else if (event === '0004' || event === '0005') {
      // msme_no?.clearValidators();
      // msme_certificate?.clearValidators();
      this.isIndustry = false
    } else {
      this.isIndustry = false
    }
    msme_no?.updateValueAndValidity(); // Update validity immediately
    msme_certificate?.updateValueAndValidity(); // Update validity immediately
  }

  OnBlurMsme(e:any){
    const MSME = (e.target as HTMLInputElement).value;
    // const msme_no=this.registrationForm.get('msme_no')?.value
    const msme_certificate = this.registrationForm.get('msme_certificate');
    if (MSME != this.formValues.msme_no) {
      this.registrationForm.patchValue({
        msme_certificate: '',
      });
      this.msmeCertificateFile = null;
      this.msme_certificateUrl = ''
      msme_certificate?.setValidators(Validators.required);
    }
    msme_certificate?.updateValueAndValidity(); // Update validity immediately
  }

  OnBlurCIN(e:any){
    const CinNValue = (e.target as HTMLInputElement).value;
    // const Cinvalue=this.registrationForm.get('cin_no')?.value
    if (CinNValue != this.formValues.cin_no) {
      this.registrationForm.patchValue({
        upload_cin: '',
      });
      this.uploadCIN = null;
      this.upload_cinUrl = ''
    }
  }
  OnBlurDocument1(e:any){
    const D1Value = (e.target as HTMLInputElement).value;
    // const D1Nvalue=this.registrationForm.get('document_1_name')?.value
    if (D1Value != this.formValues.document_1_name) {
      this.registrationForm.patchValue({
        document_1: '',
      });
      this.document1 = null;
      this.document1Url=''
    }
  }
  OnBlurDocument2(e:any){
    const D2Value = (e.target as HTMLInputElement).value;
    // const D2Nvalue=this.registrationForm.get('document_2_name')?.value
    if (D2Value != this.formValues.document_2_name) {
      this.registrationForm.patchValue({
        document_2: '',
      });
      this.document2 = null;
      this.document2Url=''
    }
  }
  onPanBlur(e:any){
    const panValue = (e.target as HTMLInputElement).value;
    // const pan_no_value=this.registrationForm.get('pan_no')?.value
    const pan_document = this.registrationForm.get('pan_document');
    if (panValue != this.formValues.pan_no) {
      this.registrationForm.patchValue({
        pan_document: '',
      });
      this.panDocument = null;
      this.pan_documentUrl=''
      this.isDisablePanDoc=false
      pan_document?.setValidators(Validators.required);
    }
    pan_document?.updateValueAndValidity();
  }

  mcaNoOnChange(evnet:any){

    const mca_number=this.registrationForm.get('mca_number');
    const mca_document=this.registrationForm.get('mca_document');
    if (evnet ==="Yes") {
      mca_number?.setValidators(Validators.required);
      mca_document?.setValidators(Validators.required);
    }else{
      mca_number?.clearValidators();
      mca_document?.clearValidators();
    }
    mca_number?.updateValueAndValidity(); // Update validity immediately
    mca_document?.updateValueAndValidity(); // Update validity immediately
  }
  mcaNoOnBlur(evnet:any){
    const panValue = (evnet.target as HTMLInputElement).value;
    // const mca_number=this.registrationForm.get('mca_number')?.value
    const mca_document=this.registrationForm.get('mca_document');
    if (panValue != this.formValues.mca_number) {
      this.registrationForm.patchValue({
        mca_document: '',
      });
      this.mcaDocument = null;
      this.mca_documentUrl = ''
      mca_document?.setValidators(Validators.required);
    }
    mca_document?.updateValueAndValidity(); // Update validity immediately
  }

  searchCustomers(event: Event, currentIndex: number): void {
    const email = (event.target as HTMLInputElement).value;
    const contactsArray = this.contactForm.get('contacts') as FormArray;
    let emailExistsInForm = false;

    this.emailErrors[currentIndex] = false;

    contactsArray.controls.forEach((control, index) => {
      if (index !== currentIndex && control.get('email_id')?.value === email) {
        emailExistsInForm = true;
      }
    });

    if (emailExistsInForm) {
      this.emailErrors[currentIndex] = true;
    } else {
      const searchSubscription = this.vendorService.search_by_email_vm_contact_detail(email).subscribe({
        next: (res: any) => {
          const status = res.message.status;
          if (status === "Success") {
            this.emailErrors[currentIndex] = true;
          } else {
            this.emailErrors[currentIndex] = false;
          }
        },
        error: (error) => {
          this.emailErrors[currentIndex] = false;
          console.error('Failed to fetch customer data:', error);
        }
      });
      this.subscriptions.push(searchSubscription);
    }
  }

  searchContactDetail(event: Event, currentIndex: number, type: 'email_id' | 'telephone' | 'mobile_phone'): void {
    const value = (event.target as HTMLInputElement).value;
    const contactsArray = this.contactForm.get('contacts') as FormArray;
    let valueExistsInForm = false;

    const errorMap = {
      email_id: this.emailErrors,
      telephone: this.telephoneErrors,
      mobile_phone: this.mobileErrors
    };

    // Reset errors for the current input type
    errorMap[type][currentIndex] = false;

    contactsArray.controls.forEach((control, index) => {
      if (index !== currentIndex && control.get(type)?.value === value) {
        valueExistsInForm = true;
      }
    });

    if (valueExistsInForm) {
      errorMap[type][currentIndex] = true;
    } else {
      const searchSubscription = this.vendorService.search_by_contact_detail(type, value).subscribe({
        next: (res: any) => {
          const status = res.message.status;
          if (status === "Success") {
            errorMap[type][currentIndex] = true;
          } else {
            errorMap[type][currentIndex] = false;
          }
        },
        error: (error) => {
          errorMap[type][currentIndex] = false;
          // console.error(`Failed to fetch ${type} data:`, error);
        }
      });
      this.subscriptions.push(searchSubscription);
    }
  }


  searchIFSCCode(ifsc: any,bankIndex: number): void {
    this.selectedBankIndex = bankIndex;
    const email = ifsc
    if (email) {
      this.isLoading=true
      const searchSubscription = this.vendorService.search_by_ifsc_code(ifsc).subscribe({
        next: (res: any) => {
          if (res.message.status) {
            this.isLoading=false
            this.ifscDialog = true
          }
          this.ifscResponse = (res.message.data as IFSCResponse[])
            .sort((a, b) => {
              const ifscA = a.ifsc ?? '';
              const ifscB = b.ifsc ?? '';
              if (ifscA < ifscB) {
                return -1;
              }
              if (ifscA > ifscB) {
                return 1;
              }
              return 0;
            });
        },
        error: (error) => {
          this.isLoading=false
          console.error('Failed to fetch ifsc dode:', error);
        }
      });
      this.subscriptions.push(searchSubscription);
    } else {
      console.log("Plaease enter IFSC Code")
    }
  }

  ifscSelected(ifsc: any) {
    if (this.selectedBankIndex !== null) {
    const bankFormGroup = (this.multipleBankDetailForm.get('multipleBank') as FormArray).at(this.selectedBankIndex) as FormGroup;
    if (bankFormGroup) {
      bankFormGroup.patchValue({
        ifsc_code: ifsc.ifsc,
        branch_name: ifsc.branch,
        bank_name: ifsc.bank,
        // bank_city: ifsc.city1,
        // bank_address: ifsc.address
      });

      // If state is available, patch the state as well
      // if (ifsc.state) {
      //   this.formatAndPatchState(ifsc.state,bankFormGroup);
      // }
    }
    this.ifscDialog = false;
    this.selectedIFSC ={}
  }
  }

  formatAndPatchState(ifscState: string,bankFormGroup:any) {
    const formattedState = this.toTitleCase(ifscState);
    const matchingState = this.state.find(s => s.label.toLowerCase() === formattedState.toLowerCase());
    if (matchingState) {
      // Patch the state value into the specific form group's state field
      bankFormGroup.get('bank_region')?.patchValue(matchingState.value);
    } else {
      console.warn(`No matching state found for: ${formattedState}`);
    }
  }
  toTitleCase(input: string): string {
    return input.toLowerCase().split(' ').map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
  }


  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}

